<template>
	<div id="container">
    <div v-if="!showRegVariables.preview">
      <nav id="sideBar-box">
        <div class="d-flex flex-column justify-content-center align-items-center w-100">
          <img class="logo" src="../images/neuroleap_logo_transparent.png" />
          <div class="w-100">
            <div :class="['navText', 'p-3', {'navClick': showNavVariables.toggleNavSelect == 'showInitInfo'}]" @click="toggleAllNavShows('showInitInfo')">
              <font-awesome-icon :icon="['fas', 'user']" />
              <span>Initial Information</span>
            </div>
            <div :class="['navText', 'p-3', {'navClick': showNavVariables.toggleNavSelect == 'showTestScore'}]" @click="toggleAllNavShows('showTestScore')">
              <font-awesome-icon :icon="['fas', 'gauge-simple-high']" />
              <span>Test Score</span>
            </div>
            <div :class="['navText', 'p-3', {'navClick': showNavVariables.toggleNavSelect == 'showAttention'}]" @click="toggleAllNavShows('showAttention')">
              <font-awesome-icon :icon="['fas', 'face-smile']" />
              <span>Attention & Emotion</span>
            </div>
            <div :class="['navText', 'p-3', {'navClick': showNavVariables.toggleNavSelect == 'showGraphs'}]" @click="toggleAllNavShows('showGraphs')">
              <font-awesome-icon :icon="['fas', 'chart-line']" />
              <span>Graph & Plots</span>
            </div>
            <div :class="['navText', 'p-3', {'navClick': showNavVariables.toggleNavSelect == 'showSummary'}]" @click="toggleAllNavShows('showSummary')">
              <font-awesome-icon :icon="['far', 'clipboard']" />
              <span>Summary & Recommendations</span>
            </div>
            <div :class="['navText', 'p-3', {'navClick': showNavVariables.toggleNavSelect == 'showRootCause'}]" @click="toggleAllNavShows('showRootCause')">
              <font-awesome-icon :icon="['fas', 'microscope']" />
              <span>Root Cause Analysis</span>
            </div>
            <div :class="['navText', 'p-3', {'navClick': showNavVariables.toggleNavSelect == 'showConfig'}]" @click="toggleAllNavShows('showConfig')">
              <font-awesome-icon :icon="['fas', 'bars-staggered']" />
              <span>Configure Menu</span>
            </div>
          </div>
        </div>
        <div class="d-flex flex-column justify-content-around align-items-center w-100">
          <button @click="showPreview()" class="orange-button">Preview</button>
          <button @click="showPreview()" class="orange-button">Generate</button>
        </div>
      </nav>
      <section id="main-box">
        <div v-if="showNavVariables.showInitInfo" id="Initial-Info-container">
          <div id="button-navigation-container">
            <span><a href="#initInfo-background-info">B</a></span>
            <span><a href="#initInfo-test-score-info">T</a></span>
            <span><a href="#initInfo-subjective-scoring-info">S</a></span>
            <span><a href="#initInfo-introduction-info">I</a></span>
          </div>
          <div>
            <h2 class="font-weight-bold" style="display: inline-block;">Initial Information</h2>
            <h4 style="display: inline-block;"><font-awesome-icon id="configRepOrderInfoIcon" :icon="['fas', 'circle-info']" style="color: #FF9B00"/></h4>
            <b-tooltip target="configRepOrderInfoIcon" triggers="hover">
              Order the Report
            </b-tooltip>
          </div>
          <div style="display: flex" id="initInfo-background-info">
            <div style="display: flex; flex-direction: column; align-items: center; flex: 1">
              <div class="profile-photo-container">
                <img alt="none" style="width:100%;height:100%;" />
              </div>
              <div>Name</div>
            </div>
            <div id="initInfo-grid" style="flex: 3">
              <div>Date of Birth:</div>
              <div>School/Hospital Name:</div>
              <div>test</div>
              <div>test</div>
              <div>Age:</div>
              <div>Program:</div>
              <div>test</div>
              <div>test</div>
              <div>Cognitive Age:</div>
              <div>Program Type:</div>
              <div>test</div>
              <div>test</div>
              <div>Parent/Guardian1:</div>
              <div>Grade:</div>
              <div>test</div>
              <div>test</div>
              <div>Parent/Guardian1 Phone:</div>
              <div>Buildings/Room:</div>
              <div>test</div>
              <div>test</div>
              <div>Parent/Guardian1 Email:</div>
              <div>Teacher:</div>
              <div>test</div>
              <div>test</div>
              <div>Parent/Guardian2:</div>
              <div>Address:</div>
              <div>test</div>
              <div>test</div>
              <div>Parent/Guardian2 Phone:</div>
              <div>Med#/Student ID:</div>
              <div>test</div>
              <div>test</div>
              <div>Parent/Guardian2 Email:</div>
              <div>Custom ID:</div>
              <div>test</div>
              <div>test</div>
              <div>Case Manager:</div>
              <div>Consent Sign Date:</div>
              <div>test</div>
              <div>test</div>
            </div>
          </div>
          <div id="initInfo-background-info" class="textBox1 p-3 mt-5">
            History/Background Information
          </div>
          <div class="textBox1 p-3 mt-5">
            Reason for Referall
          </div>
          <div class="textBox1 p-3 mt-5">
            Previous External Tests
          </div>
          <div class="textBox1 p-3 mt-5">
            History/Background Information
          </div>
          <div class="textBox1 p-3 mt-5">
            Review of Records
          </div>
          <div class="textBox1 p-3 mt-5">
            Culture and Linguistic Factors
          </div>
          <div style="display: flex; justify-content: space-between; align-items: center; margin: 1rem 0">
            <div id="initInfo-introduction-info">Introduction</div>
            <div style="display: flex; align-items: center">
              <div style="margin-right: 15px">Auto-Fill</div>
              <label class="toggle-slider-container">
                <input type="checkbox">
                <span class="slider"></span>
              </label>
            </div>
          </div>
          <div class="textBox1 p-3">
            A __ in __ shirt was seen for evaluation of __type questions were included in the screening
          </div>
          <div id="initInfo-subjective-scoring-info" style="margin-top: 1rem">
            Subjective Scoring
          </div>
          <div class="displayCard" style="width: 100%; padding: 2rem; margin: 1rem 0">
            <div style="display: flex; justify-content: space-between">
              Comprehension
              <b-form-checkbox v-model="keyToFactor.subScore.list.compreh.optsOut" true-value="true" false-value="false">
                Opt-Out
              </b-form-checkbox>
            </div>
            <div class="custom-slider-container">
              <input v-model="keyToFactor.subScore.list.compreh.variable" type="range" min="1" max="10" value="1" id="range" step="1" />
              <div class="track"></div>
              <div class="sliderticks">
                <span>1</span>
                <span>2</span>
                <span>3</span>
                <span>4</span>
                <span>5</span>
                <span>6</span>
                <span>7</span>
                <span>8</span>
                <span>9</span>
                <span>10</span>
              </div>
            </div>
          </div>
          <div class="displayCard" style="width: 100%; padding: 2rem; margin: 1rem 0">
            <div style="display: flex; justify-content: space-between">
              Problem Solving
              <b-form-checkbox v-model="keyToFactor.subScore.list.probSolv.optsOut" true-value="true" false-value="false">
                Opt-Out
              </b-form-checkbox>
            </div>
            <div class="custom-slider-container">
              <input v-model="keyToFactor.subScore.list.probSolv.variable" type="range" min="1" max="10" value="1" id="range" step="1" />
              <div class="track"></div>
              <div class="sliderticks">
                <span>1</span>
                <span>2</span>
                <span>3</span>
                <span>4</span>
                <span>5</span>
                <span>6</span>
                <span>7</span>
                <span>8</span>
                <span>9</span>
                <span>10</span>
              </div>
            </div>
          </div>
          <div class="displayCard" style="width: 100%; padding: 2rem; margin: 1rem 0">
            <div style="display: flex; justify-content: space-between">
              Intelligibility
              <b-form-checkbox v-model="keyToFactor.subScore.list.intell.optsOut" true-value="true" false-value="false">
                Opt-Out
              </b-form-checkbox>
            </div>
            <div class="custom-slider-container">
              <input v-model="keyToFactor.subScore.list.intell.variable" type="range" min="1" max="10" value="1" id="range" step="1" />
              <div class="track"></div>
              <div class="sliderticks">
                <span>1</span>
                <span>2</span>
                <span>3</span>
                <span>4</span>
                <span>5</span>
                <span>6</span>
                <span>7</span>
                <span>8</span>
                <span>9</span>
                <span>10</span>
              </div>
            </div>
          </div>
          <div id="initInfo-test-score-info" style="margin-top: 1rem">
            Test Score
          </div>
          <div class="displayCard flex-column justify-content-between align-items-center p-3 m-3">
            <div class="d-flex flex-column justify-content-center align-items-center text-center" >
              Total score
              <div v-if="dataDetails.maxScore" class="d-flex">
                <TotalScoreCircle :correct="dataDetails.correctScore" :incorrect="dataDetails.incorrectScore" :skipped="dataDetails.skippedScore" :max="dataDetails.maxScore" />
                <div style="display: grid; grid-template-columns: 15px 100px 50px; font-size: 1em; font-weight: 400; align-items: center;" class="ml-4">
                  <div style="background-color: #427733;width: 10px; height: 10px; border-radius: 2px"></div>
                  <div>Correct Pts:</div>
                  <div>{{ `${dataDetails.correctScore}/${dataDetails.maxScore}` }}</div>
                  <div style="background-color: #F29233;width: 10px; height: 10px; border-radius: 2px"></div>
                  <div>Incorrect Pts:</div>
                  <div>{{ dataDetails.incorrectScore }}</div>
                  <div style="background-color: #575B59;width: 10px; height: 10px; border-radius: 2px"></div>
                  <div>Skipped Pts:</div>
                  <div>{{dataDetails.skippedScore}}</div>
                </div>
                <div style="display: grid; grid-template-columns: 100px 50px; font-size: 1em; font-weight: 400; align-items: center;" class="ml-4">
                  <div># Correct:</div>
                  <div>{{ dataDetails.numberCorrectQuestions }}</div>
                  <div># Incorrect:</div>
                  <div>{{ dataDetails.numberIncorrectQuestions }}</div>
                  <div># Skipped:</div>
                  <div>{{dataDetails.numberSkippedQuestions}}</div>
                </div>
              </div>
              <div>
                {{scoreCategoryConversion()}}
              </div>
            </div>
          </div>
          <div class="displayCard flex-column justify-content-between align-items-center p-3 m-3">
            Top Category Skipped
            <div style="background-color: lightgrey; border-radius: .25rem; padding: 5px;" class="text-center w-75">{{dataDetails.mostSkippedCategoryObject.name}}</div>
            Category Amount Skipped
            <div style="background-color: lightgrey; border-radius: .25rem; padding: 5px;" class="text-center w-75">{{dataDetails.mostSkippedCategoryObject.amount}}</div>
          </div>
          <div class="displayCard flex-column justify-content-between align-items-center p-3 m-3">
            Strongest Category
            <div style="background-color: #427733; border-radius: .25rem; padding: 5px;" class="text-center w-75">{{dataDetails.strongestCategory}}</div>
            Weakest Category
            <div style="background-color: #F29233; border-radius: .25rem; padding: 5px;" class="text-center w-75">{{dataDetails.weakestCategory}}</div>
          </div>
        </div>
        <div v-else-if="showNavVariables.showConfig" id="Config-Order-container">
          <div>
            <h2 class="font-weight-bold" style="display: inline-block;">Configure Order</h2>
            <h4 style="display: inline-block;"><font-awesome-icon id="configRepOrderInfoIcon" :icon="['fas', 'circle-info']" style="color: #FF9B00"/></h4>
            <b-tooltip target="configRepOrderInfoIcon" triggers="hover">
              Order the Report
            </b-tooltip>
          </div>
          <div class="font-weight-normal mt-3">
            The following items will appear in the report. <br> You may drag items to customize the order of items to display.
          </div>
          <div class="mt-1">
            <draggable v-model="list">
              <div v-for="(item, index) in list" :key="index" >
                <div class="drag-item">
                  <div class="d-flex align-items-center" :class="[keyToFactor[item.ref].optsOut?'drag-item-deactivated':null]">=</div>
                  <div class="d-flex align-items-center" :style="index % 2 != 0 ? 'color: #5A5A5A' : ''" :class="[keyToFactor[item.ref].optsOut?'drag-item-deactivated':null]">{{ item.label }}</div>
                  <b-form-checkbox v-model="keyToFactor[item.ref].optsOut" true-value="true" false-value="false">Opt Out</b-form-checkbox>
                </div>
              </div>
            </draggable>
          </div>
        </div>
        <div v-else-if="showNavVariables.showTestScore" id="Test-Scores-container">
          <div class="modal-section-container">
            <div id="more-question-info-modal" class="modal">
              <div v-if="modalData.moreQuestionInfo !== null" class="modal-content">
                <div>ID: {{ modalData.moreQuestionInfo.question_id }}</div>
                <div>P/H/R/OT: {{ `${modalData.moreQuestionInfo.prompt_count}/${modalData.moreQuestionInfo.hint_count}/${modalData.moreQuestionInfo.repeat_count}/${modalData.moreQuestionInfo.over_time}` }}</div>
                <div>Question: {{ modalData.moreQuestionInfo.question_text }}</div>
                <div>Selected Answer: {{ modalData.moreQuestionInfo.child_selected_answer }}</div>
                <div>Correct Answer: {{ modalData.moreQuestionInfo.correct_answer }}</div>
                <button @click="closeModal('more-question-info-modal')">Close</button>
              </div>
            </div>
          </div>
          <div>
            <div class="d-flex justify-content-between align-items-center">
              <div>
                <h2 class="font-weight-bold" style="display: inline-block;">Test Scores</h2>
                <h4 style="display: inline-block;"><font-awesome-icon id="testScoreInfoIcon" :icon="['fas', 'circle-info']" style="color: #FF9B00"/></h4>
                <b-tooltip target="testScoreInfoIcon" triggers="hover">
                  Patient's Scores
                </b-tooltip>
              </div>
              <b-button variant="light" size="md" class="font-weight-bold border border-dark rounded" style="background-color: #FF9B00;">Show Basic Info</b-button>
            </div>
            <div class="strongest-weakest-category-container">
              <div class="grid-container">
                <div>Strongest Category</div>
                <div>Weakest Category</div>
                <div class="centering"><div class="strongest-text">{{dataDetails.strongestCategory}}</div></div>
                <div class="centering"><div class="weakest-text">{{dataDetails.weakestCategory}}</div></div>
              </div>
            </div>
            <div class="d-flex justify-content-between align-items-center">
              <div class="round-search rounded-pill d-flex justify-content-around align-items-center">
                <input type="text" placeholder="Search" class="p-1" style="width: 70%;">
                <font-awesome-icon :icon="['fas', 'magnifying-glass']" size="sm"/>
              </div>
              <div>
                <div id="leftPill" :class="[showRegVariables.testScoreDefault ? 'selectedPillHalf':null, 'left-half', 'half-pill']" @click="selectPill('left')">Default</div>
                <div id="rightPill" :class="[!showRegVariables.testScoreDefault ? 'selectedPillHalf':null, 'right-half', 'half-pill']" @click="selectPill('right')">A category at a time</div>
              </div>
            </div>

            <div v-if="showRegVariables.testScoreDefault">
              <div class="d-flex justify-content-between align-items-center mt-5">
                <div>Details</div>
                <div class="d-flex flex-nowrap">
                  <span class="d-flex flex-column justify-content-center align-items-center m-2" style="font-size: small;"><font-awesome-icon :icon="['fas', 'cloud-arrow-down']" /> Download</span>
                  <span class="d-flex flex-column justify-content-center align-items-center m-2" style="font-size: small;"><font-awesome-icon :icon="['fas', 'cloud-arrow-up']" /> Upload</span>
                </div>
              </div>
              <div style="max-height: 400px; width: 100%; overflow: auto">
                <table class="w-100">
                  <tr class="tableHeader">
                    <th>#</th>
                    <th>ID</th>
                    <th>Media</th>
                    <th>Question</th>
                    <th>P/H/R/OT</th>
                    <th>Category</th>
                    <th>Note</th>
                    <th>Score</th>
                  </tr>
                  <tr v-for="(value, index) in data" :key="value.id" class="tableElements" :style="{backgroundColor: applyTableRowColor(value), cursor: 'pointer'}" @click="openModal('more-question-info-modal', value)">
                    <td>{{ index+1 }}</td>
                    <td>...{{ value.question_id.slice(-4) }}</td>
                    <td class="media-icons-container">
                      <span>
                        <span class="red-dot" v-if="value.video_clips.length !== 0"></span>
                        <font-awesome-icon :icon="['fas', 'video']" />
                      </span>
                      <span>
                        <span class="red-dot" v-if="value.audio_clips.length !== 0"></span>
                        <font-awesome-icon :icon="['fas', 'headphones']" />
                      </span>
                      <span>
                        <span class="red-dot"></span>
                        <font-awesome-icon :icon="['fas', 'camera']" />
                      </span>
                    </td>
                    <td>{{ value.question_text }}</td>
                    <td>{{ `${value.prompt_count}/${value.hint_count}/${value.repeat_count}/${value.over_time}` }}</td>
                    <td>{{ value.category }}</td>
                    <td>{{ value.notes }}</td>
                    <td>{{ value.skipped ? 'N/A' : `${value.selected_score}/${value.highest_possible_score}` }}</td>
                  </tr>
                </table>
              </div>
              <div>Scores</div>
              <div style="max-height: 400px; width: 100%; overflow: auto">
                <table style="width: 100%">
                  <tr class="tableHeader">
                    <th></th>
                    <th>Raw Score</th>
                    <th>Percentile</th>
                    <th>Standard Score</th>
                    <th>Age Equivalent</th>
                    <th>Quotient</th>
                    <th>Rating</th>
                  </tr>
                  <tr v-for="(item, index) in categorizedDataInfo.groupedData" class="tableElements" :key="index">
                    <td>{{item.details.categoryName}}</td>
                    <td>{{item.details.rawScore}}</td>
                    <td>{{item.details.percentile}}th</td>
                    <td>{{item.details.standardScore}}</td>
                    <td>{{item.details.ageEquivalent}}</td>
                    <td>{{(item.details.quotient).toFixed(2)}}</td>
                    <td>{{item.details.rating}}</td>
                  </tr>
                </table>
              </div>
              <div class="mt-5">
                <div class="d-flex justify-content-between align-items-center">
                  <div>
                    Observer & Impression Comments
                    <font-awesome-icon id="obserCommentsInfoIcon" :icon="['fas', 'circle-info']"/>
                    <b-tooltip target="obserCommentsInfoIcon" triggers="hover">
                      Overall Test Comments
                    </b-tooltip>
                  </div>
                  <b-form-checkbox v-model="keyToFactor.obserComments.optsOut" true-value="true" false-value="false">
                    Opt-out
                  </b-form-checkbox>
                </div>
                <div>
                  <QuillEditor v-model="keyToFactor.obserComments.variable" />
                </div>
              </div>
            </div>
            <div v-else>
              <div class="gridParent-categ">
                <div style="padding: 0 1rem;">
                  <div class="d-flex justify-content-center align-items-center" style="font-size: xx-large; user-select: none;">
                    <font-awesome-icon :icon="['fas', 'caret-left']" @click="rotateCategory('left')"/>
                    {{ categorizedDataInfo.groupedData[categorizedDataInfo.groupedDataIndex].details.categoryName }}
                    <font-awesome-icon :icon="['fas', 'caret-right']" @click="rotateCategory('right')"/>
                  </div>
                  <div class="d-flex justify-content-between align-items-center">
                    <div>Scores</div>
                    <div class="d-flex flex-nowrap">
                      <span class="d-flex flex-column justify-content-center align-items-center m-2" style="font-size: small;"><font-awesome-icon :icon="['fas', 'cloud-arrow-down']" /> Download</span>
                      <span class="d-flex flex-column justify-content-center align-items-center m-2" style="font-size: small;"><font-awesome-icon :icon="['fas', 'cloud-arrow-up']" /> Upload</span>
                    </div>
                  </div>
                  <div>
                    <table class="w-100 mb-5">
                      <tr class="tableHeader">
                        <th>Raw Score</th>
                        <th>Percentile</th>
                        <th>Scaled Score</th>
                        <th>Rating</th>
                      </tr>
                      <tr class="tableElements">
                        <td>{{categorizedDataInfo.groupedData[categorizedDataInfo.groupedDataIndex].details.rawScore}}</td>
                        <td>{{categorizedDataInfo.groupedData[categorizedDataInfo.groupedDataIndex].details.percentile}}th</td>
                        <td>{{categorizedDataInfo.groupedData[categorizedDataInfo.groupedDataIndex].details.quotient.toFixed(2)}}</td>
                        <td>{{categorizedDataInfo.groupedData[categorizedDataInfo.groupedDataIndex].details.rating}}</td>
                      </tr>
                    </table>
                  </div>
                  Assesement Details
                  <div style="max-height: 50vh; overflow: auto;">
                    <table>
                      <tr class="tableHeader">
                        <th>#</th>
                        <th>ID</th>
                        <th>Media</th>
                        <th style="padding: 0 10rem">Question</th>
                        <th>P/H/R/OT</th>
                        <th style="padding: 0 10rem">Note</th>
                        <th>Score</th>
                      </tr>
                      <tr v-for="(value, index) in categorizedDataInfo.groupedData[categorizedDataInfo.groupedDataIndex].categoryQuestions" :key="value.id" class="tableElements" :style="{backgroundColor: applyTableRowColor(value)}">
                        <td>{{ index+1 }}</td>
                        <td>...{{ value.question_id.slice(-4) }}</td>
                        <td>
                          <div class="d-flex">
                            <font-awesome-icon :icon="['fas', 'video']" class="m-1"/>
                            <font-awesome-icon :icon="['fas', 'headphones']" class="m-1"/>
                            <font-awesome-icon :icon="['fas', 'camera']" class="m-1"/>
                          </div>
                        </td>
                        <td>{{ value.question_text }}</td>
                        <td>{{ `${value.prompt_count}/${value.hint_count}/${value.repeat_count}/${value.over_time}` }}</td>
                        <td>{{ value.notes }}</td>
                        <td>{{ value.skipped ? 'N/A' : `${value.selected_score}/${value.highest_possible_score}` }}</td>
                      </tr>
                    </table>
                  </div>
                </div>
                <div>
                  <div class="d-flex justify-content-center align-items-center">Observation</div>
                  <div id="quill-categComment">
                      <QuillEditor v-model="keyToFactor.categComments.list[`categComment` + `${categorizedDataInfo.groupedDataIndex}`].variable" :forceSet="categorizedDataInfo.groupedDataIndex"/>
                  </div>
                  <b-form-checkbox v-model="keyToFactor.categComments.list[`categComment` + `${categorizedDataInfo.groupedDataIndex}`].optsOut" true-value="true" false-value="false">
                    Opt-out
                </b-form-checkbox>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-else-if="showNavVariables.showAttention" id="Attention-Emotion-container">
          <h2 class="font-weight-bold" style="display: inline-block;">Attention & Emotion</h2>
          <h4 style="display: inline-block;"><font-awesome-icon id="configRepAttEmoInfoIcon" :icon="['fas', 'circle-info']" style="color: #FF9B00"/></h4>
          <b-tooltip target="configRepAttEmoInfoIcon" triggers="hover">
            Patient Social Functioning Notes
          </b-tooltip>
          <div class="mt-5">
            <div class="d-flex justify-content-between align-items-center">
              <div>
                {{ keyToFactor.atteSocEmoFunc.label }}
                <font-awesome-icon id="atteSocEmoFuncInfoIcon" :icon="['fas', 'circle-info']"/>
                <b-tooltip target="atteSocEmoFuncInfoIcon" triggers="hover">
                  Social Function Notes
                </b-tooltip>
              </div>
              <b-form-checkbox v-model="keyToFactor.atteSocEmoFunc.optsOut" true-value="true" false-value="false">
                Opt-out
              </b-form-checkbox>
            </div>
            <div>
              <QuillEditor v-model="keyToFactor.atteSocEmoFunc.variable" />
            </div>
          </div>
          <div class="mt-5">
            <div class="d-flex justify-content-between align-items-center">
              <div>
                {{ keyToFactor.riskSum.label }}
                <font-awesome-icon id="riskSumInfoIcon" :icon="['fas', 'circle-info']"/>
                <b-tooltip target="riskSumInfoIcon" triggers="hover">
                  Summary of Social Risks
                </b-tooltip>
              </div>
              <b-form-checkbox v-model="keyToFactor.riskSum.optsOut" true-value="true" false-value="false">
                Opt-out
              </b-form-checkbox>
            </div>
            <div>
              <QuillEditor v-model="keyToFactor.riskSum.variable" />
            </div>
          </div>
        </div>
        <div v-else-if="showNavVariables.showGraphs" id="Graphs-Plots-container">
          <h2 class="font-weight-bold" style="display: inline-block;">Graphs & Plots</h2>
          <h4 style="display: inline-block;"><font-awesome-icon id="configRepAttEmoInfoIcon" :icon="['fas', 'circle-info']" style="color: #FF9B00"/></h4>
          <b-tooltip target="configRepAttEmoInfoIcon" triggers="hover">
            Patient Social Functioning Notes
          </b-tooltip>
          <h4 class="mt-5">Diagram</h4>
          <div>
            <div class="radioGrid mb-5">
              <div>Types:</div>
              <div v-for="(item) in plotVariables.plotSelect" :key="item.label">
                <span @click="chooseGraphics(item.label)">
                  <span :class="[keyToFactor[item.ref].optsOut ? 'categGraphOptedOut' : null ,item.isActive ? 'categGraphSelected' : null, 'categGraphOptions']"></span>
                  {{ item.label }}
                </span>
              </div>
              <div>Categories:</div>
              <div @click="chooseGraphics('worse 3')">
                <div class="categGraphOptions" id="selectWorst3Opt"></div>
                Weakest 3
              </div>
              <div @click="chooseGraphics('all')">
                <div class="categGraphOptions" id="selectAllOpt"></div>
                All
              </div>
            </div>
          </div>
          <div v-if="keyToFactor.barChart.worst.isActive && !keyToFactor.barChart.optsOut" class="plotDrop-container accordion-container">
            <div  class="plotDrop-title accordion d-flex justify-content-center align-items-center position-relative" @click="e => toggleAccordion(e)">
              Bar Chart: Weakest 3
              <font-awesome-icon :icon="['fas', 'angle-down']" style="position: absolute; right: 10"/>
            </div>
            <div class="panel">
              <div class="d-flex justify-content-center align-items-center position-relative w-100 h-100">
                <div class="displayCard flex-column justify-content-between align-items-center p-3 m-2">
                  <div class="d-flex justify-content-center align-items-center position-relative w-100">
                    <div class="custom-dropdown w-50 m-1">
                      <div class="selected-option d-flex justify-content-between align-items-center" @click="toggleGeneralDropDowns('weakest')">
                        {{ keyToFactor.barChart.worst.dropDownWeakest.selectedValue }}
                        <font-awesome-icon :icon="['fas', 'angle-down']" />
                      </div>
                      <ul v-show="keyToFactor.barChart.worst.dropDownWeakest.isDropdownOpen" class='p-0 w-100'>
                        <li v-for="option in keyToFactor.barChart.worst.dropDownWeakest.options" :key="option" @click="selectOptionGeneral(option, 'barChartWeak3')">
                          <span :style="option == keyToFactor.barChart.worst.dropDownWeakest.selectedValue ? 'visibility: visible' : 'visibility: hidden;'">
                            <font-awesome-icon :icon="['fas', 'check']" />
                          </span>
                          {{ option }}
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div class="d-flex flex-column justify-content-between align-items-center m-2">
                    <div class="pillSelection rounded-pill p-1 d-flex">
                      <span v-for="(item, index) in keyToFactor.barChart.worst.pastChoose" :class="[item.isActive ? 'pillSelected' : null, 'p-1', 'rounded-pill']" :key="index" @click="changePastWorstCateg(item.label)">{{ item.label }}</span>
                    </div>
                    <BarChartVertical :ref="keyToFactor.barChart.worst.ref" :dataInput="usedDataBarChartWorst" :suggest="keyToFactor.barChart.worst.suggest" :width="screenWidth*.5" :height="190" 
                      :mean="keyToFactor.barChart.worst.mean" :median="keyToFactor.barChart.worst.median" :standDeviation="keyToFactor.barChart.worst.stanDeviation" :variance="keyToFactor.barChart.worst.variance"/>
                  </div>
                </div>
                <div :class="['plotDrop-sideBar', keyToFactor.barChart.worst.plotCustomize.sideBarActive ? 'plotDrop-sideBar-open' : null]">
                  <div class="d-flex justify-content-center">
                    <b-form-checkbox class="m-1" v-model="keyToFactor.barChart.worst.mean" true-value="true" false-value="false">
                      Mean
                    </b-form-checkbox>
                    <b-form-checkbox class="m-1" v-model="keyToFactor.barChart.worst.median" true-value="true" false-value="false">
                      Median
                    </b-form-checkbox>
                    <b-form-checkbox class="m-1" v-model="keyToFactor.barChart.worst.stanDeviation" true-value="true" false-value="false">
                      Standard Deviation
                    </b-form-checkbox>
                    <b-form-checkbox class="m-1" v-model="keyToFactor.barChart.worst.variance" true-value="true" false-value="false">
                      Variance
                    </b-form-checkbox>
                  </div>
                  <div class="d-flex justify-content-center">
                    <b-form-checkbox class="m-1" v-model="keyToFactor.barChart.worst.suggest" true-value="true" false-value="false">
                      Suggestions
                    </b-form-checkbox>
                  </div>
                  <div style="display: flex">
                    <div class="text-center" style="font-size: 1.3em; display: flex; justify-content: center; align-items: center">Remove Outliers</div>
                    <div class="custom-slider-container">
                      <input @input="e => lowerSliderChange(e, keyToFactor.barChart.worst)" type="range" min="0" max="100" value="0" step="1" />
                      <input @input="e => upperSliderChange(e, keyToFactor.barChart.worst)" type="range" min="0" max="100" value="100" step="1" />
                      <div class="track"></div>
                    </div>
                  </div>
                  <div class="text-center" style="font-size:1.3em">Drag to Choose which Data is Used</div>
                  <div class="d-flex justify-content-center">
                    <div class="plotDrop-draggable-used">
                      <div class="text-center" style="font-size: 1.2em">Used Categories (max 3)</div>
                      <draggable v-model="keyToFactor.barChart.worst.worstData" group="barChartWorst" v-bind="dragOptions" style="column-width: 150px; flex-grow: 1;">
                        <div v-for="(item,index) in usedDataBarChartWorst" :key="index">
                          {{ `${item.variable}` }}
                        </div>
                      </draggable>
                    </div>
                    <div class="plotDrop-draggable-removed">
                      <div class="text-center" style="font-size: 1.2em">Removed Categories</div>
                      <draggable v-model="keyToFactor.barChart.worst.worstDataRemoved" group="barChartWorst" :move="checkMoveWorst" v-bind="dragOptions" style="column-width: 150px; flex-grow: 1;">
                        <div v-for="(item,index) in removedDataBarChartWorst" :key="index">
                          {{ item.variable }}
                        </div>
                      </draggable>
                    </div>
                  </div>
                </div>
              </div>
              <div class="d-flex justify-content-center align-items-center w-100">
                <div @click="toggleCustomizeSideBar('barChart', 'worst'); reDrawGraphs(keyToFactor.barChart.worst.ref)" class="plotDrop-customizeB">
                  {{ keyToFactor.barChart.worst.plotCustomize.sideBarActive ? 'Close' : 'Customize' }}
                </div>
              </div>
            </div>  
          </div>
          <div v-if="keyToFactor.barChart.all.isActive && !keyToFactor.barChart.optsOut" class="plotDrop-container accordion-container">
            <div @click="e => toggleAccordion(e)" class="plotDrop-title accordion d-flex justify-content-center align-items-center position-relative">
              Bar Chart: All
              <font-awesome-icon :icon="['fas', 'angle-down']" style="position: absolute; right: 10"/>
            </div>
            <div class="panel">
              <div class="d-flex justify-content-center align-items-center position-relative w-100 h-100">
                <div class="displayCard flex-column justify-content-between align-items-center position-relative p-3 m-2">
                  <div>All</div>
                  <BarChartHorizontal :ref="keyToFactor.barChart.all.ref" :dataInput="usedDataBarChartAll" :suggest="keyToFactor.barChart.all.suggest" :width="screenWidth*.5" :height="60*categorizedDataInfo.numberOfCateg" 
                    :mean="keyToFactor.barChart.all.mean" :median="keyToFactor.barChart.all.median" :standDeviation="keyToFactor.barChart.all.stanDeviation" :variance="keyToFactor.barChart.all.variance"/>
                </div>
                <div :class="['plotDrop-sideBar', keyToFactor.barChart.all.plotCustomize.sideBarActive ? 'plotDrop-sideBar-open' : null]">
                  <div class="d-flex justify-content-center">
                    <b-form-checkbox class="m-1" v-model="keyToFactor.barChart.all.mean" true-value="true" false-value="false">
                      Mean
                    </b-form-checkbox>
                    <b-form-checkbox class="m-1" v-model="keyToFactor.barChart.all.median" true-value="true" false-value="false">
                      Median
                    </b-form-checkbox>
                    <b-form-checkbox class="m-1" v-model="keyToFactor.barChart.all.stanDeviation" true-value="true" false-value="false">
                      Standard Deviation
                    </b-form-checkbox>
                    <b-form-checkbox class="m-1" v-model="keyToFactor.barChart.all.variance" true-value="true" false-value="false">
                      Variance
                    </b-form-checkbox>
                  </div>
                  <div class="d-flex justify-content-center">
                    <b-form-checkbox class="m-1" v-model="keyToFactor.barChart.all.suggest" true-value="true" false-value="false">
                      Suggestions
                    </b-form-checkbox>
                  </div>
                  <div style="display: flex">
                    <div class="text-center" style="font-size: 1.3em; display: flex; justify-content: center; align-items: center">Remove Outliers</div>
                    <div class="custom-slider-container">
                      <input @input="e => lowerSliderChange(e, keyToFactor.barChart.all)" type="range" min="0" max="100" value="0" step="1" />
                      <input @input="e => upperSliderChange(e, keyToFactor.barChart.all)" type="range" min="0" max="100" value="100" step="1" />
                      <div class="track"></div>
                    </div>
                  </div>
                  <div class="text-center" style="font-size: 1.3em">Drag to Order & Choose which Data is Used</div>
                  <div class="d-flex justify-content-center">
                    <div class="plotDrop-draggable-used">
                      <div class="text-center" style="font-size: 1.2em">Used Categories</div>
                      <draggable v-model="keyToFactor.barChart.all.allData" group="barChartAll" v-bind="dragOptions" style="column-width: 150px; flex-grow: 1;">
                        <div v-for="(item,index) in usedDataBarChartAll" :key="index">
                          {{ `${index+1}: ${item.variable}: ${item.value}` }}
                        </div>
                      </draggable>
                    </div>
                    <div class="plotDrop-draggable-removed">
                      <div class="text-center" style="font-size: 1.2em">Removed Categories</div>
                      <draggable v-model="keyToFactor.barChart.all.allDataRemoved" group="barChartAll" v-bind="dragOptions" style="column-width: 150px; flex-grow: 1;">
                        <div v-for="(item,index) in removedDataBarChartAll" :key="index">
                          {{ item.variable }}
                        </div>
                      </draggable>
                    </div>
                  </div>
                </div>
              </div>
              <div class="d-flex justify-content-center align-items-center w-100">
                <div @click="toggleCustomizeSideBar('barChart', 'all'); reDrawGraphs(keyToFactor.barChart.all.ref)" class="plotDrop-customizeB">
                  {{ keyToFactor.barChart.all.plotCustomize.sideBarActive ? 'Close' : 'Customize' }} 
                </div>
              </div>
            </div>  
          </div>
          <div v-if="keyToFactor.scattPlot.worst.isActive && !keyToFactor.scattPlot.optsOut" class="plotDrop-container accordion-container">
            <div @click="e => toggleAccordion(e)" class="plotDrop-title accordion d-flex justify-content-center align-items-center position-relative">
              Scatter Plot: Weakest 3
              <font-awesome-icon :icon="['fas', 'angle-down']" style="position: absolute; right: 10"/>
            </div>
            <div class="panel">
              <div class="d-flex justify-content-center align-items-center position-relative w-100 h-100">
                <div class="displayCard flex-column justify-content-between align-items-center p-3 m-2">
                  <div class="d-flex flex-column justify-content-between align-items-center m-2">
                    <div>Weakest</div>
                    <ScatterPlot :ref="keyToFactor.scattPlot.worst.ref" :dataInput="usedDataScattPlotWorst" :suggest="keyToFactor.scattPlot.worst.suggest" :width="screenWidth*.5" :height="190" 
                      :mean="keyToFactor.scattPlot.worst.mean" :median="keyToFactor.scattPlot.worst.median" :standDeviation="keyToFactor.scattPlot.worst.stanDeviation" :variance="keyToFactor.scattPlot.worst.variance"/>
                  </div>
                </div>
                <div :class="['plotDrop-sideBar', keyToFactor.scattPlot.worst.plotCustomize.sideBarActive ? 'plotDrop-sideBar-open' : null]">
                  <div class="d-flex justify-content-center">
                    <b-form-checkbox class="m-1" v-model="keyToFactor.scattPlot.worst.mean" true-value="true" false-value="false">
                      Mean
                    </b-form-checkbox>
                    <b-form-checkbox class="m-1" v-model="keyToFactor.scattPlot.worst.median" true-value="true" false-value="false">
                      Median
                    </b-form-checkbox>
                    <b-form-checkbox class="m-1" v-model="keyToFactor.scattPlot.worst.stanDeviation" true-value="true" false-value="false">
                      Standard Deviation
                    </b-form-checkbox>
                    <b-form-checkbox class="m-1" v-model="keyToFactor.scattPlot.worst.variance" true-value="true" false-value="false">
                      Variance
                    </b-form-checkbox>
                  </div>
                  <div class="d-flex justify-content-center">
                    <b-form-checkbox class="m-1" v-model="keyToFactor.scattPlot.worst.suggest" true-value="true" false-value="false">
                      Suggestions
                    </b-form-checkbox>
                  </div>
                  <div style="display: flex">
                    <div class="text-center" style="font-size: 1.3em; display: flex; justify-content: center; align-items: center">Remove Outliers</div>
                    <div class="custom-slider-container">
                      <input @input="e => lowerSliderChange(e, keyToFactor.scattPlot.worst)" type="range" min="0" max="100" value="0" step="1" />
                      <input @input="e => upperSliderChange(e, keyToFactor.scattPlot.worst)" type="range" min="0" max="100" value="100" step="1" />
                      <div class="track"></div>
                    </div>
                  </div>
                  <div class="text-center" style="font-size:1.3em">Drag to Choose which Data is Used</div>
                  <div class="d-flex justify-content-center">
                    <div class="plotDrop-draggable-used">
                      <div class="text-center" style="font-size: 1.2em">Used Categories (max 3)</div>
                      <draggable v-model="keyToFactor.scattPlot.worst.worstData" group="scattPlotWorst" v-bind="dragOptions" style="column-width: 150px; flex-grow: 1;">
                        <div v-for="(item,index) in usedDataScattPlotWorst" :key="index">
                          {{ `${item.variable}` }}
                        </div>
                      </draggable>
                    </div>
                    <div class="plotDrop-draggable-removed">
                      <div class="text-center" style="font-size: 1.2em">Removed Categories</div>
                      <draggable v-model="keyToFactor.scattPlot.worst.worstDataRemoved" group="scattPlotWorst" :move="checkMoveWorst" v-bind="dragOptions" style="column-width: 150px; flex-grow: 1;">
                        <div v-for="(item,index) in removedDataScattPlotWorst" :key="index">
                          {{ item.variable }}
                        </div>
                      </draggable>
                    </div>
                  </div>
                </div>
              </div>
              <div class="d-flex justify-content-center align-items-center w-100">
                <div @click="toggleCustomizeSideBar('scattPlot', 'worst'); reDrawGraphs(keyToFactor.scattPlot.worst.ref)" class="plotDrop-customizeB">
                  {{ keyToFactor.scattPlot.worst.plotCustomize.sideBarActive ? 'Close' : 'Customize' }}
                </div>
              </div>
            </div> 
          </div>
          <div v-if="keyToFactor.scattPlot.all.isActive && !keyToFactor.scattPlot.optsOut" class="plotDrop-container accordion-container">
            <div @click="e => toggleAccordion(e)" class="plotDrop-title accordion d-flex justify-content-center align-items-center position-relative">
              Scatter Plot: All
              <font-awesome-icon :icon="['fas', 'angle-down']" style="position: absolute; right: 10"/>
            </div>
            <div class="panel">
              <div class="d-flex justify-content-center align-items-center position-relative w-100 h-100">
                <div class="displayCard flex-column justify-content-between align-items-center position-relative p-3 m-2">
                  <div>All</div>
                  <ScatterPlot :ref="keyToFactor.scattPlot.all.ref" :dataInput="usedDataScattPlotAll" :suggest="keyToFactor.scattPlot.all.suggest" :width="screenWidth*.5" :height="190" 
                    :mean="keyToFactor.scattPlot.all.mean" :median="keyToFactor.scattPlot.all.median" :standDeviation="keyToFactor.scattPlot.all.stanDeviation" :variance="keyToFactor.scattPlot.all.variance"/>
                </div>
                <div :class="['plotDrop-sideBar', keyToFactor.scattPlot.all.plotCustomize.sideBarActive ? 'plotDrop-sideBar-open' : null]">
                  <div class="d-flex justify-content-center">
                    <b-form-checkbox class="m-1" v-model="keyToFactor.scattPlot.all.mean" true-value="true" false-value="false">
                      Mean
                    </b-form-checkbox>
                    <b-form-checkbox class="m-1" v-model="keyToFactor.scattPlot.all.median" true-value="true" false-value="false">
                      Median
                    </b-form-checkbox>
                    <b-form-checkbox class="m-1" v-model="keyToFactor.scattPlot.all.stanDeviation" true-value="true" false-value="false">
                      Standard Deviation
                    </b-form-checkbox>
                    <b-form-checkbox class="m-1" v-model="keyToFactor.scattPlot.all.variance" true-value="true" false-value="false">
                      Variance
                    </b-form-checkbox>
                  </div>
                  <div class="d-flex justify-content-center">
                    <b-form-checkbox class="m-1" v-model="keyToFactor.scattPlot.all.suggest" true-value="true" false-value="false">
                      Suggestions
                    </b-form-checkbox>
                  </div>
                  <div style="display: flex">
                    <div class="text-center" style="font-size: 1.3em; display: flex; justify-content: center; align-items: center">Remove Outliers</div>
                    <div class="custom-slider-container">
                      <input @input="e => lowerSliderChange(e, keyToFactor.scattPlot.all)" type="range" min="0" max="100" value="0" step="1" />
                      <input @input="e => upperSliderChange(e, keyToFactor.scattPlot.all)" type="range" min="0" max="100" value="100" step="1" />
                      <div class="track"></div>
                    </div>
                  </div>
                  <div class="text-center" style="font-size: 1.3em">Drag to Order & Choose which Data is Used</div>
                  <div class="d-flex justify-content-center">
                    <div class="plotDrop-draggable-used">
                      <div class="text-center" style="font-size: 1.2em">Used Categories</div>
                      <draggable v-model="keyToFactor.scattPlot.all.allData" group="scattPlotAll" v-bind="dragOptions" style="column-width: 150px; flex-grow: 1;">
                        <div v-for="(item,index) in usedDataScattPlotAll" :key="index">
                          {{ `${index+1}: ${item.variable}` }}
                        </div>
                      </draggable>
                    </div>
                    <div class="plotDrop-draggable-removed">
                      <div class="text-center" style="font-size: 1.2em">Removed Categories</div>
                      <draggable v-model="keyToFactor.scattPlot.all.allDataRemoved" group="scattPlotAll" v-bind="dragOptions" style="column-width: 150px; flex-grow: 1;">
                        <div v-for="(item,index) in removedDataScattPlotAll" :key="index">
                          {{ item.variable }}
                        </div>
                      </draggable>
                    </div>
                  </div>
                </div>
              </div>
              <div class="d-flex justify-content-center align-items-center w-100">
                <div @click="toggleCustomizeSideBar('scattPlot', 'all'); reDrawGraphs(keyToFactor.scattPlot.all.ref)" class="plotDrop-customizeB">
                  {{ keyToFactor.scattPlot.all.plotCustomize.sideBarActive ? 'Close' : 'Customize' }} 
                </div>
              </div>
            </div>  
          </div>
          <div v-if="keyToFactor.radarChart.worst.isActive && !keyToFactor.radarChart.optsOut" class="plotDrop-container accordion-container">
            <div @click="e => toggleAccordion(e)" class="plotDrop-title accordion d-flex justify-content-center align-items-center position-relative">
              Radar Chart: Weakest 3
              <font-awesome-icon :icon="['fas', 'angle-down']" style="position: absolute; right: 10"/>
            </div>
            <div class="panel">
              <div class="d-flex justify-content-center align-items-center position-relative w-100 h-100">
                <div class="displayCard flex-column justify-content-between align-items-center p-3 m-2">
                  <div class="d-flex flex-column justify-content-between align-items-center m-2">
                    <div>Weakest</div>
                    <RadarChart :ref="keyToFactor.radarChart.worst.ref" :dataInput="usedDataRadarChartWorst" :suggest="keyToFactor.radarChart.worst.suggest" :width="screenWidth*.5" :height="190"/>
                  </div>
                </div>
                <div :class="['plotDrop-sideBar', keyToFactor.radarChart.worst.plotCustomize.sideBarActive ? 'plotDrop-sideBar-open' : null]">
                  <div class="d-flex justify-content-center">
                    <b-form-checkbox class="m-1" v-model="keyToFactor.radarChart.worst.suggest" true-value="true" false-value="false">
                      Suggestions
                    </b-form-checkbox>
                  </div>
                  <div style="display: flex">
                    <div class="text-center" style="font-size: 1.3em; display: flex; justify-content: center; align-items: center">Remove Outliers</div>
                    <div class="custom-slider-container">
                      <input @input="e => lowerSliderChange(e, keyToFactor.radarChart.worst)" type="range" min="0" max="100" value="0" step="1" />
                      <input @input="e => upperSliderChange(e, keyToFactor.radarChart.worst)" type="range" min="0" max="100" value="100" step="1" />
                      <div class="track"></div>
                    </div>
                  </div>
                  <div class="text-center" style="font-size:1.3em">Drag to Choose which Data is Used</div>
                  <div class="d-flex justify-content-center">
                    <div class="plotDrop-draggable-used">
                      <div class="text-center" style="font-size: 1.2em">Used Categories (max 3)</div>
                      <draggable v-model="keyToFactor.radarChart.worst.worstData" group="radarChartWorst" v-bind="dragOptions" style="column-width: 150px; flex-grow: 1;">
                        <div v-for="(item,index) in usedDataRadarChartWorst" :key="index">
                          {{ `${item.variable}` }}
                        </div>
                      </draggable>
                    </div>
                    <div class="plotDrop-draggable-removed">
                      <div class="text-center" style="font-size: 1.2em">Removed Categories</div>
                      <draggable v-model="keyToFactor.radarChart.worst.worstDataRemoved" group="radarChartWorst" :move="checkMoveWorst" v-bind="dragOptions" style="column-width: 150px; flex-grow: 1;">
                        <div v-for="(item,index) in removedDataRadarChartWorst" :key="index">
                          {{ item.variable }}
                        </div>
                      </draggable>
                    </div>
                  </div>
                </div>
              </div>
              <div class="d-flex justify-content-center align-items-center w-100">
                <div @click="toggleCustomizeSideBar('radarChart', 'worst'); reDrawGraphs(keyToFactor.radarChart.worst.ref)" class="plotDrop-customizeB">
                  {{ keyToFactor.radarChart.worst.plotCustomize.sideBarActive ? 'Close' : 'Customize' }}
                </div>
              </div>
            </div> 
          </div>
          <div v-if="keyToFactor.radarChart.all.isActive && !keyToFactor.radarChart.optsOut" class="plotDrop-container accordion-container">
            <div @click="e => toggleAccordion(e)" class="plotDrop-title accordion d-flex justify-content-center align-items-center position-relative">
              Radar Chart: All
              <font-awesome-icon :icon="['fas', 'angle-down']" style="position: absolute; right: 10"/>
            </div>
            <div class="panel">
              <div class="d-flex justify-content-center align-items-center position-relative w-100 h-100">
                <div class="displayCard flex-column justify-content-between align-items-center position-relative p-3 m-2">
                  <div>All</div>
                  <RadarChart :ref="keyToFactor.radarChart.all.ref" :dataInput="usedDataRadarChartAll" :suggest="keyToFactor.radarChart.all.suggest" :width="screenWidth*.5" :height="190"/>
                </div>
                <div :class="['plotDrop-sideBar', keyToFactor.radarChart.all.plotCustomize.sideBarActive ? 'plotDrop-sideBar-open' : null]">
                  <div class="d-flex justify-content-center">
                    <b-form-checkbox class="m-1" v-model="keyToFactor.radarChart.all.suggest" true-value="true" false-value="false">
                      Suggestions
                    </b-form-checkbox>
                  </div>
                  <div style="display: flex">
                    <div class="text-center" style="font-size: 1.3em; display: flex; justify-content: center; align-items: center">Remove Outliers</div>
                    <div class="custom-slider-container">
                      <input @input="e => lowerSliderChange(e, keyToFactor.radarChart.all)" type="range" min="0" max="100" value="0" step="1" />
                      <input @input="e => upperSliderChange(e, keyToFactor.radarChart.all)" type="range" min="0" max="100" value="100" step="1" />
                      <div class="track"></div>
                    </div>
                  </div>
                  <div class="text-center" style="font-size: 1.3em">Drag to Order & Choose which Data is Used</div>
                  <div class="d-flex justify-content-center">
                    <div class="plotDrop-draggable-used">
                      <div class="text-center" style="font-size: 1.2em">Used Categories</div>
                      <draggable v-model="keyToFactor.radarChart.all.allData" group="radarChartAll" v-bind="dragOptions" style="column-width: 150px; flex-grow: 1;">
                        <div v-for="(item,index) in usedDataRadarChartAll" :key="index">
                          {{ `${index+1}: ${item.variable}` }}
                        </div>
                      </draggable>
                    </div>
                    <div class="plotDrop-draggable-removed">
                      <div class="text-center" style="font-size: 1.2em">Removed Categories</div>
                      <draggable v-model="keyToFactor.radarChart.all.allDataRemoved" group="radarChartAll" v-bind="dragOptions" style="column-width: 150px; flex-grow: 1;">
                        <div v-for="(item,index) in removedDataRadarChartAll" :key="index">
                          {{ item.variable }}
                        </div>
                      </draggable>
                    </div>
                  </div>
                </div>
              </div>
              <div class="d-flex justify-content-center align-items-center w-100">
                <div @click="toggleCustomizeSideBar('radarChart', 'all'); reDrawGraphs(keyToFactor.radarChart.all.ref)" class="plotDrop-customizeB">
                  {{ keyToFactor.radarChart.all.plotCustomize.sideBarActive ? 'Close' : 'Customize' }}
                </div>
              </div>
            </div>  
          </div>
          <div v-if="keyToFactor.pieChart.worst.isActive && !keyToFactor.pieChart.optsOut" class="plotDrop-container accordion-container">
            <div @click="e => toggleAccordion(e)" class="plotDrop-title accordion d-flex justify-content-center align-items-center position-relative">
              Pie Chart: Weakest 3
              <font-awesome-icon :icon="['fas', 'angle-down']" style="position: absolute; right: 10"/>
            </div>
            <div class="panel">
              <div class="d-flex justify-content-center align-items-center position-relative w-100 h-100">
                <div class="displayCard flex-column justify-content-between align-items-center p-3 m-2">
                  <div class="d-flex flex-column justify-content-between align-items-center m-2">
                    <div>Weakest</div>
                    <PieChart :dataInput="usedDataPieChartWorst" :width="screenWidth*.5" :height="190"/>
                  </div>
                </div>
                <div :class="['plotDrop-sideBar', keyToFactor.pieChart.worst.plotCustomize.sideBarActive ? 'plotDrop-sideBar-open' : null]">
                  <div class="text-center" style="font-size: 1.3em">Remove Outliers</div>
                  <div class="d-flex justify-content-center m-2">
                    <vue-slider v-model="keyToFactor.pieChart.worst.outlierValues" :dotStyle="{background: '#FF9B00', border: '2px solid #FF9B00'}" :enable-cross="false" class="w-75"></vue-slider>
                  </div>
                  <div class="text-center" style="font-size:1.3em">Drag to Choose which Data is Used</div>
                  <div class="d-flex justify-content-center">
                    <div class="plotDrop-draggable-used">
                      <div class="text-center" style="font-size: 1.2em">Used Categories (max 3)</div>
                      <draggable v-model="keyToFactor.pieChart.worst.worstData" group="pieChartWorst" v-bind="dragOptions" style="column-width: 150px; flex-grow: 1;">
                        <div v-for="(item,index) in usedDataPieChartWorst" :key="index">
                          {{ `${item.variable}` }}
                        </div>
                      </draggable>
                    </div>
                    <div class="plotDrop-draggable-removed">
                      <div class="text-center" style="font-size: 1.2em">Removed Categories</div>
                      <draggable v-model="keyToFactor.pieChart.worst.worstDataRemoved" group="pieChartWorst" :move="checkMoveWorst" v-bind="dragOptions" style="column-width: 150px; flex-grow: 1;">
                        <div v-for="(item,index) in removedDataPieChartWorst" :key="index">
                          {{ item.variable }}
                        </div>
                      </draggable>
                    </div>
                  </div>
                </div>
              </div>
              <div class="d-flex justify-content-center align-items-center w-100">
                <div @click="toggleCustomizeSideBar('pieChart', 'worst')" class="plotDrop-customizeB">
                  {{ keyToFactor.pieChart.worst.plotCustomize.sideBarActive ? 'Close' : 'Customize' }}
                </div>
              </div>
            </div> 
          </div>
          <div v-if="keyToFactor.pieChart.all.isActive && !keyToFactor.pieChart.optsOut" class="plotDrop-container accordion-container">
            <div @click="e => toggleAccordion(e)" class="plotDrop-title accordion d-flex justify-content-center align-items-center position-relative">
              Pie Chart: All
              <font-awesome-icon :icon="['fas', 'angle-down']" style="position: absolute; right: 10"/>
            </div>
            <div class="panel">
              <div class="d-flex justify-content-center align-items-center position-relative w-100 h-100">
                <div class="displayCard flex-column justify-content-between align-items-center position-relative p-3 m-2">
                  <div>All</div>
                  <PieChart :dataInput="usedDataPieChartAll" :width="screenWidth*.5" :height="190"/>
                </div>
                <div :class="['plotDrop-sideBar', keyToFactor.pieChart.all.plotCustomize.sideBarActive ? 'plotDrop-sideBar-open' : null]">
                  <div class="text-center" style="font-size: 1.3em">Remove Outliers</div>
                  <div class="d-flex justify-content-center m-2">
                    <vue-slider v-model="keyToFactor.pieChart.all.outlierValues" :dotStyle="{background: '#FF9B00', border: '2px solid #FF9B00'}" :enable-cross="false" class="w-75"></vue-slider>
                  </div>
                  <div class="text-center" style="font-size: 1.3em">Drag to Order & Choose which Data is Used</div>
                  <div class="d-flex justify-content-center">
                    <div class="plotDrop-draggable-used">
                      <div class="text-center" style="font-size: 1.2em">Used Categories</div>
                      <draggable v-model="keyToFactor.pieChart.all.allData" group="pieChartAll" v-bind="dragOptions" style="column-width: 150px; flex-grow: 1;">
                        <div v-for="(item,index) in usedDataPieChartAll" :key="index">
                          {{ `${index+1}: ${item.variable}` }}
                        </div>
                      </draggable>
                    </div>
                    <div class="plotDrop-draggable-removed">
                      <div class="text-center" style="font-size: 1.2em">Removed Categories</div>
                      <draggable v-model="keyToFactor.pieChart.all.allDataRemoved" group="pieChartAll" v-bind="dragOptions" style="column-width: 150px; flex-grow: 1;">
                        <div v-for="(item,index) in removedDataPieChartAll" :key="index">
                          {{ item.variable }}
                        </div>
                      </draggable>
                    </div>
                  </div>
                </div>
              </div>
              <div class="d-flex justify-content-center align-items-center w-100">
                <div @click="toggleCustomizeSideBar('pieChart', 'all')" class="plotDrop-customizeB">
                  {{ keyToFactor.pieChart.all.plotCustomize.sideBarActive ? 'Close' : 'Customize' }} 
                </div>
              </div>
            </div>  
          </div>
          <div v-if="keyToFactor.lineChart.worst.isActive && !keyToFactor.lineChart.optsOut" class="plotDrop-container accordion-container">
            <div @click="e => toggleAccordion(e)" class="plotDrop-title accordion d-flex justify-content-center align-items-center position-relative">
              Line Chart: Weakest 3
              <font-awesome-icon :icon="['fas', 'angle-down']" style="position: absolute; right: 10"/>
            </div>
            <div class="panel">
              <div class="d-flex justify-content-center align-items-center position-relative w-100 h-100">
                <div class="displayCard flex-column justify-content-between align-items-center p-3 m-2">
                  <div class="d-flex flex-column justify-content-between align-items-center m-2">
                    <div>Weakest</div>
                    <LineChart :ref="keyToFactor.lineChart.worst.ref" :dataInput="usedDataLineChartWorst" :suggest="keyToFactor.lineChart.worst.suggest" :width="screenWidth*.5" :height="190" 
                      :mean="keyToFactor.lineChart.worst.mean" :median="keyToFactor.lineChart.worst.median" :standDeviation="keyToFactor.lineChart.worst.stanDeviation" :variance="keyToFactor.lineChart.worst.variance"/>
                  </div>
                </div>
                <div :class="['plotDrop-sideBar', keyToFactor.lineChart.worst.plotCustomize.sideBarActive ? 'plotDrop-sideBar-open' : null]">
                  <div class="d-flex justify-content-center">
                    <b-form-checkbox class="m-1" v-model="keyToFactor.lineChart.worst.mean" true-value="true" false-value="false">
                      Mean
                    </b-form-checkbox>
                    <b-form-checkbox class="m-1" v-model="keyToFactor.lineChart.worst.median" true-value="true" false-value="false">
                      Median
                    </b-form-checkbox>
                    <b-form-checkbox class="m-1" v-model="keyToFactor.lineChart.worst.stanDeviation" true-value="true" false-value="false">
                      Standard Deviation
                    </b-form-checkbox>
                    <b-form-checkbox class="m-1" v-model="keyToFactor.lineChart.worst.variance" true-value="true" false-value="false">
                      Variance
                    </b-form-checkbox>
                  </div>
                  <div class="d-flex justify-content-center">
                    <b-form-checkbox class="m-1" v-model="keyToFactor.lineChart.worst.suggest" true-value="true" false-value="false">
                      Suggestions
                    </b-form-checkbox>
                  </div>
                  <div style="display: flex">
                    <div class="text-center" style="font-size: 1.3em; display: flex; justify-content: center; align-items: center">Remove Outliers</div>
                    <div class="custom-slider-container">
                      <input @input="e => lowerSliderChange(e, keyToFactor.lineChart.worst)" type="range" min="0" max="100" value="0" step="1" />
                      <input @input="e => upperSliderChange(e, keyToFactor.lineChart.worst)" type="range" min="0" max="100" value="100" step="1" />
                      <div class="track"></div>
                    </div>
                  </div>
                  <div class="text-center" style="font-size:1.3em">Drag to Choose which Data is Used</div>
                  <div class="d-flex justify-content-center">
                    <div class="plotDrop-draggable-used">
                      <div class="text-center" style="font-size: 1.2em">Used Categories (max 3)</div>
                      <draggable v-model="keyToFactor.lineChart.worst.worstData" group="lineChartWorst" v-bind="dragOptions" style="column-width: 150px; flex-grow: 1;">
                        <div v-for="(item,index) in usedDataLineChartWorst" :key="index">
                          {{ `${item.variable}` }}
                        </div>
                      </draggable>
                    </div>
                    <div class="plotDrop-draggable-removed">
                      <div class="text-center" style="font-size: 1.2em">Removed Categories</div>
                      <draggable v-model="keyToFactor.lineChart.worst.worstDataRemoved" group="lineChartWorst" :move="checkMoveWorst" v-bind="dragOptions" style="column-width: 150px; flex-grow: 1;">
                        <div v-for="(item,index) in removedDataLineChartWorst" :key="index">
                          {{ item.variable }}
                        </div>
                      </draggable>
                    </div>
                  </div>
                </div>
              </div>
              <div class="d-flex justify-content-center align-items-center w-100">
                <div @click="toggleCustomizeSideBar('lineChart', 'worst'); reDrawGraphs(keyToFactor.lineChart.worst.ref)" class="plotDrop-customizeB">
                  {{ keyToFactor.lineChart.worst.plotCustomize.sideBarActive ? 'Close' : 'Customize' }}
                </div>
              </div>
            </div> 
          </div>
          <div v-if="keyToFactor.lineChart.all.isActive && !keyToFactor.lineChart.optsOut" class="plotDrop-container accordion-container">
            <div @click="e => toggleAccordion(e)" class="plotDrop-title accordion d-flex justify-content-center align-items-center position-relative">
              Line Chart: All
              <font-awesome-icon :icon="['fas', 'angle-down']" style="position: absolute; right: 10"/>
            </div>
            <div class="panel">
              <div class="d-flex justify-content-center align-items-center position-relative w-100 h-100">
                <div class="displayCard flex-column justify-content-between align-items-center position-relative p-3 m-2">
                  <div>All</div>
                  <LineChart :ref="keyToFactor.lineChart.all.ref" :dataInput="usedDataLineChartAll" :suggest="keyToFactor.lineChart.all.suggest" :width="screenWidth*.5" :height="190" 
                    :mean="keyToFactor.lineChart.all.mean" :median="keyToFactor.lineChart.all.median" :standDeviation="keyToFactor.lineChart.all.stanDeviation" :variance="keyToFactor.lineChart.all.variance"/>
                </div>
                <div :class="['plotDrop-sideBar', keyToFactor.lineChart.all.plotCustomize.sideBarActive ? 'plotDrop-sideBar-open' : null]">
                  <div class="d-flex justify-content-center">
                    <b-form-checkbox class="m-1" v-model="keyToFactor.lineChart.all.mean" true-value="true" false-value="false">
                      Mean
                    </b-form-checkbox>
                    <b-form-checkbox class="m-1" v-model="keyToFactor.lineChart.all.median" true-value="true" false-value="false">
                      Median
                    </b-form-checkbox>
                    <b-form-checkbox class="m-1" v-model="keyToFactor.lineChart.all.stanDeviation" true-value="true" false-value="false">
                      Standard Deviation
                    </b-form-checkbox>
                    <b-form-checkbox class="m-1" v-model="keyToFactor.lineChart.all.variance" true-value="true" false-value="false">
                      Variance
                    </b-form-checkbox>
                  </div>
                  <div class="d-flex justify-content-center">
                    <b-form-checkbox class="m-1" v-model="keyToFactor.lineChart.all.suggest" true-value="true" false-value="false">
                      Suggestions
                    </b-form-checkbox>
                  </div>
                  <div style="display: flex">
                    <div class="text-center" style="font-size: 1.3em; display: flex; justify-content: center; align-items: center">Remove Outliers</div>
                    <div class="custom-slider-container">
                      <input @input="e => lowerSliderChange(e, keyToFactor.lineChart.all)" type="range" min="0" max="100" value="0" step="1" />
                      <input @input="e => upperSliderChange(e, keyToFactor.lineChart.all)" type="range" min="0" max="100" value="100" step="1" />
                      <div class="track"></div>
                    </div>
                  </div>
                  <div class="text-center" style="font-size: 1.3em">Drag to Order & Choose which Data is Used</div>
                  <div class="d-flex justify-content-center">
                    <div class="plotDrop-draggable-used">
                      <div class="text-center" style="font-size: 1.2em">Used Categories</div>
                      <draggable v-model="keyToFactor.lineChart.all.allData" group="lineChartAll" v-bind="dragOptions" style="column-width: 150px; flex-grow: 1;">
                        <div v-for="(item,index) in usedDataLineChartAll" :key="index">
                          {{ `${index+1}: ${item.variable}` }}
                        </div>
                      </draggable>
                    </div>
                    <div class="plotDrop-draggable-removed">
                      <div class="text-center" style="font-size: 1.2em">Removed Categories</div>
                      <draggable v-model="keyToFactor.lineChart.all.allDataRemoved" group="lineChartAll" v-bind="dragOptions" style="column-width: 150px; flex-grow: 1;">
                        <div v-for="(item,index) in removedDataLineChartAll" :key="index">
                          {{ item.variable }}
                        </div>
                      </draggable>
                    </div>
                  </div>
                </div>
              </div>
              <div class="d-flex justify-content-center align-items-center w-100">
                <div @click="toggleCustomizeSideBar('lineChart', 'all'); reDrawGraphs(keyToFactor.lineChart.all.ref)" class="plotDrop-customizeB">
                  {{ keyToFactor.lineChart.all.plotCustomize.sideBarActive ? 'Close' : 'Customize' }}
                </div>
              </div>
            </div>  
          </div>
        </div>
        <div v-else-if="showNavVariables.showRootCause" id="Root-Cause-Analysis-container">
          <div>
            <h2 class="font-weight-bold" style="display: inline-block;">Root Cause Analysis</h2>
            <h4 style="display: inline-block;"><font-awesome-icon id="rootCauseIcon" :icon="['fas', 'circle-info']" style="color: #FF9B00"/></h4>
            <b-tooltip target="rootCauseIcon" triggers="hover">
              Score Comparisons
            </b-tooltip>
          </div>
          <div class="mt-5">
            <div class="nav-button-group">
              <button @click="physicalMappingButton">Physical Mapping</button>
              <button @click="compareSimiliarButton">Compare Similiar</button>
              <button @click="compareSettingsButton">Comparison Settings</button>
              <button>Edit</button>
            </div>
            <div>
              Coming Soon
            </div>
          </div>
        </div>
        <div v-else-if="showNavVariables.showSummary" id="Summary-Recomm-container">
          <div>
            <h2 class="font-weight-bold" style="display: inline-block;">Summary & Recommendations</h2>
            <h4 style="display: inline-block;"><font-awesome-icon id="configRepGrahicsInfoIcon" :icon="['fas', 'circle-info']" style="color: #FF9B00"/></h4>
            <b-tooltip target="configRepGrahicsInfoIcon" triggers="hover">
              Custom Graphics Representations
            </b-tooltip>
          </div>
          <div class="mt-5">
            <div class="d-flex justify-content-between align-items-center">
              <div>
                {{ keyToFactor.summConclus.label }}
              </div>
              <b-form-checkbox v-model="keyToFactor.summConclus.optsOut" true-value="true" false-value="false">
                Opt-out
              </b-form-checkbox>
            </div>
            <div>
              <QuillEditor v-model="keyToFactor.summConclus.variable" />
            </div>
          </div>
          <div>
            <div class="d-flex justify-content-between align-items-center">
              <div>
                Normative Data
              </div>
              <b-form-checkbox v-model="keyToFactor.summConclus.optsOut" true-value="true" false-value="false">
                Opt-out
              </b-form-checkbox>
            </div>
            <div v-for="(area, areaKey, indexArea) in nestedGrouping" :key="`${indexArea}-area`">
              <div v-for="(type, typeKey, indexType) in area.typeQuestions" :key="`${indexType}-type`">
                <div style="display: grid; grid-template-columns: auto 100px; row-gap: 5px; column-gap: 75px;">
                  <div style="text-align: center">{{typeKey}}:type</div>
                  <span style="display: inline-flex; justify-content: center; align-items: center; background-color: lightgrey; border-radius: 5px; font-weight: 400; padding: 5px">{{type.details.correctPoints}}%</span>
                </div>
                <div v-for="(category, categoryKey, indexCategory) in type.categoryQuestions" :key="`${indexCategory}-category`">
                  <div style="display: grid; grid-template-columns: auto 100px; row-gap: 5px; column-gap: 75px;">
                    <div style="text-align: center">{{categoryKey}}:category</div>
                    <span style="display: inline-flex; justify-content: center; align-items: center; background-color: lightgrey; border-radius: 5px; font-weight: 400; padding: 5px">{{category.details.correctPoints}}%</span>
                  </div>
                </div>
              </div>
              <div style="display: grid; grid-template-columns: auto 100px; row-gap: 5px; column-gap: 75px;">
                <div style="text-align: center">{{areaKey}}:area</div>
                <span style="display: inline-flex; justify-content: center; align-items: center; background-color: lightgrey; border-radius: 5px; font-weight: 400; padding: 5px">{{area.details.correctPoints}}%</span>
              </div>
            </div>
          </div>
          <div class="mt-5">
            <div class="d-flex justify-content-between align-items-center">
              <div>
                {{ keyToFactor.techDetail.label }}-Additional Comments
                <font-awesome-icon id="techDetailsInfoIcon" :icon="['fas', 'circle-info']"/>
                <b-tooltip target="techDetailsInfoIcon" triggers="hover">
                  Browser, Scanner, ....
                </b-tooltip>
              </div>
              <b-form-checkbox v-model="keyToFactor.techDetail.optsOut" true-value="true" false-value="false">
                Opt-out
              </b-form-checkbox>
            </div>
            <div style="margin-top: 1rem">
              <span class="mr-5">Browser: {{ browserInfo.name }}</span>
              <span class="mr-5">Version: {{browserInfo.version}}</span>
              <span class="mr-5">Hardware: Unknown</span>
            </div>
          </div>
          <div class="mt-5">
            <div class="d-flex justify-content-between align-items-center">
              <div>
                Technology - Additional Comments
              </div>
              <b-form-checkbox v-model="keyToFactor.additComments.optsOut" true-value="true" false-value="false">
                Opt-out
              </b-form-checkbox>
            </div>
            <div>
              <QuillEditor v-model="keyToFactor.techDetail.variable" />
            </div>
          </div>
        </div>
      </section>
    </div>
	</div>
</template>

<script>
  import BarChartVertical from './subComponents/BarChartVertical.vue';
  import BarChartHorizontal from './subComponents/BarChartHorizontal.vue';
  import ScatterPlot from './subComponents/ScatterPlot.vue';
  import RadarChart from './subComponents/RadarChart.vue';
  import PieChart from './subComponents/PieChart.vue';
  import LineChart from './subComponents/LineChart.vue';
  import VueSlider from 'vue-slider-component';
  import 'vue-slider-component/theme/default.css';
  import QuillEditor from './subComponents/QuillEditor.vue';
  import draggable from 'vuedraggable';

  import pdfMake from 'pdfmake/build/pdfmake';
  import pdfFonts from "pdfmake/build/vfs_fonts";
  pdfMake.vfs = pdfFonts.pdfMake.vfs;
  import htmlToPdfmake from 'html-to-pdfmake';

  import TotalScoreCircle from './subComponents/TotalScoreCircle.vue'

  import instance from '../axios.js';

	export default {
    components: {
      BarChartVertical,
      BarChartHorizontal,
      ScatterPlot,
      RadarChart,
      PieChart,
      LineChart,
      draggable,
      VueSlider,
      QuillEditor,
      TotalScoreCircle
    },
    data() {
      return {  
        reportID: null,
        data: null,
        browserInfo: {name: null, version: null},
        screenWidth: null,
        preferredName: 'Phil Thomson',
        appSubtitle: 'null',
        includeCateg: 'null',
        dataDetails: {
          weakestCategory: null,
          strongestCategory: null,
          correctScore: null,
          incorrectScore: null,
          skippedScore: null,
          maxScore: null,
          numberCorrectQuestions: null,
          numberIncorrectQuestions: null,
          numberSkippedQuestions: null,
          numberQuestions: null,
          mostSkippedCategoryObject: {
            name: null,
            amount: null
          },
        },
        modalData: {
          moreQuestionInfo: null,
        },
        profilePic: null,
        profilePicTemp: null,
        orderedScoresByCateg: null,
        listDisplayTextBoxes: null,
        keyToFactor: {
          subScore: {
            label: "Subjective Scoring",
            optsOut: false,
            list:{ 
              compreh: {label: 'Comprehension', variable: 'N/A', optsOut: false},
              probSolv: {label: 'Problem Solving', variable: 'N/A', optsOut: false},
              intell: {label: 'Intelligibility', variable: 'N/A', optsOut: false}
            },
            dropDownMood: {
              selectedValue: 'Select Mood',
              isDropdownOpen: false,
              options: ['tense', 'excited', 'cheerful', 'relaxed', 'calm', 'bored', 'sad', 'irrated', 'neutral'],
            },
            dropDownShirtColor: {
              selectedValue: 'Select Shirt Color',
              isDropdownOpen: false,
              options: ['red', 'green', 'blue', 'orange', 'yellow', 'indigo', 'violet'],
            },
          },
          additComments: {
            label: "Additional Comments",
            variable: null,
            optsOut: false
          },
          categComments: {
            label: "Category Comments",
            optsOut: false,
            list: {}
          },
          barChart: {
            label: "Bar Chart",
            optsOut: false,
            worst: {
              ref: 'barChartWorstRef',
              isActive: true,
              worstData: null,
              worstDataRemoved: [],
              mean: true,
              median: true,
              stanDeviation: true,
              variance: true,
              suggest: false,
              outlierValues: [0,100],
              plotCustomize: {
                dropDownActive: false,
                sideBarActive: false,
              },
              dropDownWeakest: {
                selectedValue: 'Weakest Three Categories',
                isDropdownOpen: false,
                options: ['Weakest Category', 'Weakest Two Categories', 'Weakest Three Categories'],
              },
              pastChoose: [
                {label: "past 1 month",isActive: true},
                {label: "past 3 months",isActive: false},
                {label: "past 1 year",isActive: false},
                {label: "past 3 years",isActive: false},
                {label: "all",isActive: false},
              ],
            },
            all: {
              ref: 'barChartAllRef',
              isActive: true,
              allData: null,
              allDataRemoved: [],
              mean: true,
              median: true,
              stanDeviation: true,
              variance: true,
              suggest: true,
              outlierValues: [0,100],
              plotCustomize: {
                dropDownActive: false,
                sideBarActive: false,
              },
            },
          },
          scattPlot: {
            label: "Scatter Plot",
            optsOut: false,
            worst: {
              ref: 'scattPlotWorstRef',
              isActive: true,
              worstData: null,
              worstDataRemoved: [],
              mean: true,
              median: true,
              stanDeviation: true,
              variance: true,
              suggest: false,
              outlierValues: [0,100],
              plotCustomize: {
                dropDownActive: false,
                sideBarActive: false,
              },
            },
            all: {
              ref: 'scattPlotAllRef',
              isActive: true,
              allData: null,
              allDataRemoved: [],
              mean: true,
              median: true,
              stanDeviation: true,
              variance: true,
              suggest: true,
              outlierValues: [0,100],
              plotCustomize: {
                dropDownActive: false,
                sideBarActive: false,
              },
            },
          },
          lineChart: {
            label: "Line Chart",
            optsOut: false,
            worst: {
              ref: 'lineChartWorstRef',
              isActive: true,
              worstData: null,
              worstDataRemoved: [],
              mean: true,
              median: true,
              stanDeviation: true,
              variance: true,
              suggest: false,
              outlierValues: [0,100],
              plotCustomize: {
                dropDownActive: false,
                sideBarActive: false,
              },
            },
            all: {
              ref: 'lineChartAllRef',
              isActive: true,
              allData: null,
              allDataRemoved: [],
              mean: true,
              median: true,
              stanDeviation: true,
              variance: true,
              suggest: true,
              outlierValues: [0,100],
              plotCustomize: {
                dropDownActive: false,
                sideBarActive: false,
              },
            },
          },
          pieChart: {
            label: "Pie Chart",
            optsOut: false,
            worst: {
              isActive: true,
              worstData: null,
              worstDataRemoved: [],
              outlierValues: [0,100],
              plotCustomize: {
                dropDownActive: false,
                sideBarActive: false,
              },
            },
            all: {
              isActive: true,
              allData: null,
              allDataRemoved: [],
              outlierValues: [0,100],
              plotCustomize: {
                dropDownActive: false,
                sideBarActive: false,
              },
            },
          },
          radarChart: {
            label: "Radar Chart",
            optsOut: false,
            worst: {
              ref: 'radarChartWorstRef',
              isActive: true,
              worstData: null,
              worstDataRemoved: [],
              suggest: false,
              outlierValues: [0,100],
              plotCustomize: {
                dropDownActive: false,
                sideBarActive: false,
              },
            },
            all: {
              ref: 'radarChartAllRef',
              isActive: true,
              allData: null,
              allDataRemoved: [],
              suggest: true,
              outlierValues: [0,100],
              plotCustomize: {
                dropDownActive: false,
                sideBarActive: false,
              },
            },
          },
          obserComments: {
            label: "Observation + Impression Comments",
            variable: null,
            optsOut: false
          },
          atteSocEmoFunc: {
            label: "Attention, Social & Emotional Functioning",
            variable: null,
            optsOut: false
          },
          riskSum: {
            label: "Risk Summary",
            variable: null,
            optsOut: false
          },
          summConclus: {
            label: "Summary of Conclusion",
            variable: null,
            optsOut: false
          },
          furthTask: {
            label: "Furthur Task + Recommendation",
            variable: null,
            optsOut: false
          },
          accomInstru: {
            label: "Accommodation",
            variable: null,
            optsOut: false
          },
          techDetail: {
            label: "Technology Details",
            variable: null,
            optsOut: false
          },
          testScore: {
            label: "Test Score",
            optsOut: true
          }
        },
        list: [
          {label: 'Subjective scoring (intelligibility, comprehension etc)', ref: 'subScore'},
          {label: 'Bar chart', ref: 'barChart'},
          {label: 'Scatter plot', ref: 'scattPlot'},
          {label: 'Line chart', ref: 'lineChart'},
          {label: 'Pie chart', ref: 'pieChart'},
          {label: 'Radar chart', ref: 'radarChart'},
          {label: 'Additional Comments', ref: 'additComments'},
          {label: 'Category Comments', ref: 'categComments'},
          {label: 'Observations & Impression (for each category typically)', ref: 'obserComments'},
          {label: 'Attention, Emotions & Social Functioning (mood i.e.)', ref: 'atteSocEmoFunc'},
          {label: 'Risk Summary', ref: 'riskSum'},
          {label: 'Summary of Conclusion', ref: 'summConclus'},
          {label: 'Futher testing and Recommendation', ref: 'furthTask'},
          {label: 'Accommodation and Instruction', ref: 'accomInstru'},
          {label: 'Technology details (AAC device i.e.)', ref: 'techDetail'},
          {label: 'Test Score', ref: 'testScore'},
        ],
        dragOptions: {
          animation: 200,
        },
        sliders: {
          data: ['N/A', '1', '2', '3', '4', '5', '6', '7', '8', '9', '10'],
          process: () => [
            [0, 10, { backgroundColor: '#878587' }],
            [10, 50, { backgroundColor: '#E69D95' }],
            [50, 80, { backgroundColor: '#FFF9AA' }],
            [80, 100, { backgroundColor: '#9AE69F' }]
          ],
        },
        showRegVariables: {
          testScoreDefault: true,
          preview: false,
        },
        showNavVariables: {
          showInitInfo: true,
          showConfig: false,
          showTestScore: false,
          showAttention: false,
          showGraphs: false,
          showSummary: false,
          showRootCause: false,
          toggleNavSelect: "showInitInfo",
        },
        categorizedDataInfo: {
          groupedDataIndex: 0,
          numberOfCateg: null,
          groupedData: null,
        },
        nestedGrouping: null,
        plotVariables: {
          plotSelect: {
            barChart: {label: "Bar Chart", isActive: false, ref: 'barChart'},
            scattPlot: {label: "Scatter Plot", isActive: false, ref: 'scattPlot'},
            radarChart: {label: "Radar Chart", isActive: false, ref: 'radarChart'},
            pieChart: {label: "Pie Chart", isActive: false, ref: 'pieChart'},
            lineChart: {label: "Line Chart", isActive: false, ref: 'lineChart'}
          },
        },
      }
    },
    async created() {
      try {
        this.reportID =  this.$route.params.reportID;
        let result = await instance.get(`/api/question-result/report/${this.reportID}`);
        this.data = result.data;

        this.screenWidth = window.innerWidth;
        this.browserInfo = this.getBrowserInfo();

        for (let i = 0; i < this.list.length; i++) {
          this.list[i].letter = `${String.fromCharCode(i+65)}`
        }

        //group questions by category and tally points
        let categorizedQuestions = {};
        let correctScore = 0;
        let skippedScore = 0;
        let maxScore = 0;
        let numberCorrectQuestions = 0;
        let numberskippedQuestions = 0;
        this.numberQuestions = this.data.length;
        this.data.forEach(item => {
          if (item.skipped) {
            skippedScore += item.highest_possible_score;
            numberskippedQuestions += 1;
          } else {
            if (item.selected_score == item.highest_possible_score) {
              numberCorrectQuestions += 1;
            }
            correctScore += item.selected_score;
          }
          maxScore += item.highest_possible_score;

          if (!categorizedQuestions[item.category]) {
            categorizedQuestions[item.category] = {
              details: {},
              categoryQuestions: []
            };
          }
          categorizedQuestions[item.category].categoryQuestions.push(item);
        });
        this.dataDetails.correctScore = correctScore;
        this.dataDetails.incorrectScore = maxScore - correctScore - skippedScore;
        this.dataDetails.skippedScore = skippedScore;
        this.dataDetails.maxScore = maxScore;
        this.dataDetails.numberCorrectQuestions = numberCorrectQuestions;
        this.dataDetails.numberIncorrectQuestions = this.numberQuestions - numberCorrectQuestions - numberskippedQuestions;
        this.dataDetails.numberSkippedQuestions = numberskippedQuestions;
        
        categorizedQuestions = Object.values(categorizedQuestions);
        this.categorizedDataInfo.groupedData = categorizedQuestions;
        this.categorizedDataInfo.numberOfCateg = this.categorizedDataInfo.groupedData.length;

        let nestedGrouping = {};
        this.data.forEach(question => {
          if (!nestedGrouping[question.area]) {
            nestedGrouping[question.area] = {
              details: {
                area: question.area,
                correctPoints: 0,
                maxPoints: 0,
                skippedPoints: 0,
                incorrectPoints: 0,
              },
              typeQuestions: {}
            };
          }
          let detailsArea = nestedGrouping[question.area].details;
          detailsArea.correctPoints += (question.skipped ? 0 : question.highest_possible_score);
          detailsArea.maxPoints += question.highest_possible_score;
          detailsArea.skippedPoints += (question.skipped ? question.highest_possible_score : 0);
          detailsArea.incorrectPoints += (question.skipped ? 0 : question.highest_possible_score - question.selected_score);

          if (!nestedGrouping[question.area].typeQuestions[question.type]) {
            nestedGrouping[question.area].typeQuestions[question.type] = {
              details: {
                type: question.type,
                correctPoints: 0,
                maxPoints: 0,
                skippedPoints: 0,
                incorrectPoints: 0,
              },
              categoryQuestions: {}
            }
          }
          let detailsType = nestedGrouping[question.area].typeQuestions[question.type].details;
          detailsType.correctPoints += (question.skipped ? 0 : question.highest_possible_score);
          detailsType.maxPoints += question.highest_possible_score;
          detailsType.skippedPoints += (question.skipped ? question.highest_possible_score : 0);
          detailsType.incorrectPoints += (question.skipped ? 0 : question.highest_possible_score - question.selected_score);

          if (!nestedGrouping[question.area].typeQuestions[question.type].categoryQuestions[question.category]) {
            nestedGrouping[question.area].typeQuestions[question.type].categoryQuestions[question.category] = {
              details: {
                category: question.category,
                correctPoints: 0,
                maxPoints: 0,
                skippedPoints: 0,
                incorrectPoints: 0,
              },
              subCategoryQuestions: {}
            }
          }
          let detailsCategory = nestedGrouping[question.area].typeQuestions[question.type].categoryQuestions[question.category].details;
          detailsCategory.correctPoints += (question.skipped ? 0 : question.highest_possible_score);
          detailsCategory.maxPoints += question.highest_possible_score;
          detailsCategory.skippedPoints += (question.skipped ? question.highest_possible_score : 0);
          detailsCategory.incorrectPoints += (question.skipped ? 0 : question.highest_possible_score - question.selected_score);

          if (!nestedGrouping[question.area].typeQuestions[question.type].categoryQuestions[question.category].subCategoryQuestions[question.sub_category]) {
            nestedGrouping[question.area].typeQuestions[question.type].categoryQuestions[question.category].subCategoryQuestions[question.sub_category] = {
              details: {
                subCategory: question.sub_category,
                correctPoints: 0,
                maxPoints: 0,
                skippedPoints: 0,
                incorrectPoints: 0,
              },
              Questions: []
            }
          }
          let detailsSubCategory = nestedGrouping[question.area].typeQuestions[question.type].categoryQuestions[question.category].subCategoryQuestions[question.sub_category].details;
          detailsSubCategory.correctPoints += (question.skipped ? 0 : question.highest_possible_score);
          detailsSubCategory.maxPoints += question.highest_possible_score;
          detailsSubCategory.skippedPoints += (question.skipped ? question.highest_possible_score : 0);
          detailsSubCategory.incorrectPoints += (question.skipped ? 0 : question.highest_possible_score - question.selected_score);

          nestedGrouping[question.area].typeQuestions[question.type].categoryQuestions[question.category].subCategoryQuestions[question.sub_category].Questions.push(question);
        });
        this.nestedGrouping = nestedGrouping;

        //set variables for each category
        for (let i = 0; i < categorizedQuestions.length; i++) {
          this.$set(this.keyToFactor.categComments.list, `categComment` + `${i}`, 
            {variable: null, label: this.categorizedDataInfo.groupedData[i].categoryQuestions[0].category, optsOut: false}
          );
        }

        //sort by totalscore in ascending order if tie then sort by numofquestions in descending order
        let scoreArray = [];
        let categoryScorePoints;
        let maxScorePoints;
        let categorySkippedPoints;
        let categoryQuestionsSkipped;
        let categoryMostSkipped = {
          name: null,
          amount: 0,
        };
        for (const item of this.categorizedDataInfo.groupedData) {
          categoryScorePoints = 0;
          maxScorePoints = 0;
          categorySkippedPoints = 0;
          categoryQuestionsSkipped = 0;
          for (const question of item.categoryQuestions) {
            categoryScorePoints += question.selected_score;
            maxScorePoints += question.highest_possible_score;
            categorySkippedPoints += question.highest_possible_score;
            if (question.skipped) {
              categoryQuestionsSkipped += 1;
            }
          }

          if (categoryMostSkipped.amount <= categoryQuestionsSkipped) {
            categoryMostSkipped.name = item.categoryQuestions[0].category;
            categoryMostSkipped.amount = categoryQuestionsSkipped;
          }

          item.details = {
            ...item.details,
            categoryName: item.categoryQuestions[0].category,
            rawScore: categoryScorePoints,
            percentile: Math.floor(Math.random() * 101),
            standardScore: ((categoryScorePoints - (categoryScorePoints + 10))/3).toFixed(2),
            ageEquivalent: 'Some Age',
            quotient: (categoryScorePoints/maxScorePoints),
            rating: Math.floor(Math.random() * 101),
            numOfQuestions: item.categoryQuestions.length,
            skippedPoints: categorySkippedPoints
          }
          scoreArray.push({name: item.categoryQuestions[0].category, quotient: ((categoryScorePoints/maxScorePoints)*100), numOfQuestions: item.categoryQuestions.length});
        }

        this.dataDetails.mostSkippedCategoryObject = categoryMostSkipped;

        scoreArray.sort((a, b) => { 
          if (a.quotient !== b.quotient) {
            return a.quotient - b.quotient;
          }
          else {
            return b.numOfQuestions - a.numOfQuestions
          }
        });

        this.dataDetails.weakestCategory = scoreArray[0].name;
        this.dataDetails.strongestCategory = scoreArray[scoreArray.length-1].name;

        //make & set graph data for alldata and worstdata
        let graphDataWorst = [];
        let graphDataWorstRemoved = [];
        let graphDataAll = scoreArray.map(obj => {  //{variable, value}
          return {variable: obj.name, value: obj.quotient.toFixed(2)};
        })
        if (scoreArray.length >= 3) {
          graphDataWorst = graphDataAll.slice(0,3);
          graphDataWorstRemoved = graphDataAll.slice(3,scoreArray.length);
        }
        else {
          graphDataWorst = graphDataAll.slice(0,scoreArray.length);
        }

        Object.values(this.plotVariables.plotSelect).forEach(item => {
          this.keyToFactor[item.ref].all.allData = [...graphDataAll];
          this.keyToFactor[item.ref].worst.worstData = [...graphDataWorst];
          this.keyToFactor[item.ref].worst.worstDataRemoved = [...graphDataWorstRemoved];
        });
        this.orderedScoresByCateg = [...graphDataAll];
      } catch (e) {
        console.error(e);
      }
    },
    watch: {
      'showNavVariables.showGraphs': function(newV) {
        if (newV) {
          for (const key in this.plotVariables.plotSelect) {
            this.plotVariables.plotSelect[key].isActive = false;
          }
        }
      }
    },
    computed: {
      usedDataBarChartAll() {
        let temp = [...this.keyToFactor.barChart.all.allData];
        return temp.filter(element => (element.value >= this.keyToFactor.barChart.all.outlierValues[0] && element.value <= this.keyToFactor.barChart.all.outlierValues[1]));
      },
      removedDataBarChartAll() {
        let temp = [...this.keyToFactor.barChart.all.allDataRemoved];
        return temp.filter(element => (element.value >= this.keyToFactor.barChart.all.outlierValues[0] && element.value <= this.keyToFactor.barChart.all.outlierValues[1]));
      },
      usedDataScattPlotAll() {
        let temp = [...this.keyToFactor.scattPlot.all.allData];
        return temp.filter(element => (element.value >= this.keyToFactor.scattPlot.all.outlierValues[0] && element.value <= this.keyToFactor.scattPlot.all.outlierValues[1]));
      },
      removedDataScattPlotAll() {
        let temp = [...this.keyToFactor.scattPlot.all.allDataRemoved];
        return temp.filter(element => (element.value >= this.keyToFactor.scattPlot.all.outlierValues[0] && element.value <= this.keyToFactor.scattPlot.all.outlierValues[1]));
      },
      usedDataRadarChartAll() {
        let temp = [...this.keyToFactor.radarChart.all.allData];
        return temp.filter(element => (element.value >= this.keyToFactor.radarChart.all.outlierValues[0] && element.value <= this.keyToFactor.radarChart.all.outlierValues[1]));
      },
      removedDataRadarChartAll() {
        let temp = [...this.keyToFactor.radarChart.all.allDataRemoved];
        return temp.filter(element => (element.value >= this.keyToFactor.radarChart.all.outlierValues[0] && element.value <= this.keyToFactor.radarChart.all.outlierValues[1]));
      },
      usedDataPieChartAll() {
        let temp = [...this.keyToFactor.pieChart.all.allData];
        return temp.filter(element => (element.value >= this.keyToFactor.pieChart.all.outlierValues[0] && element.value <= this.keyToFactor.pieChart.all.outlierValues[1]));
      },
      removedDataPieChartAll() {
        let temp = [...this.keyToFactor.pieChart.all.allDataRemoved];
        return temp.filter(element => (element.value >= this.keyToFactor.pieChart.all.outlierValues[0] && element.value <= this.keyToFactor.pieChart.all.outlierValues[1]));
      },
      usedDataLineChartAll() {
        let temp = [...this.keyToFactor.lineChart.all.allData];
        return temp.filter(element => (element.value >= this.keyToFactor.lineChart.all.outlierValues[0] && element.value <= this.keyToFactor.lineChart.all.outlierValues[1]));
      },
      removedDataLineChartAll() {
        let temp = [...this.keyToFactor.lineChart.all.allDataRemoved];
        return temp.filter(element => (element.value >= this.keyToFactor.lineChart.all.outlierValues[0] && element.value <= this.keyToFactor.lineChart.all.outlierValues[1]));
      },
      usedDataBarChartWorst() {
        let temp = [...this.keyToFactor.barChart.worst.worstData];
        let newV = this.keyToFactor.barChart.worst.dropDownWeakest.selectedValue;
        temp = temp.filter(element => (element.value >= this.keyToFactor.barChart.worst.outlierValues[0] && element.value <= this.keyToFactor.barChart.worst.outlierValues[1]));
        temp.sort((a, b) => a.value - b.value);
        if (newV == 'Weakest Category') {
          return temp.slice(0,1);
        }
        else if (newV == 'Weakest Two Categories') {
          return temp.slice(0,2);
        }
        else {
          return temp.slice(0,3);
        }
      },
      removedDataBarChartWorst() {
        let temp = [...this.keyToFactor.barChart.worst.worstDataRemoved];
        return temp.filter(element => (element.value >= this.keyToFactor.barChart.worst.outlierValues[0] && element.value <= this.keyToFactor.barChart.worst.outlierValues[1]));
      },
      usedDataScattPlotWorst() {
        let temp = [...this.keyToFactor.scattPlot.worst.worstData];
        return temp.filter(element => (element.value >= this.keyToFactor.scattPlot.worst.outlierValues[0] && element.value <= this.keyToFactor.scattPlot.worst.outlierValues[1]));
      },
      removedDataScattPlotWorst() {
        let temp = [...this.keyToFactor.scattPlot.worst.worstDataRemoved];
        return temp.filter(element => (element.value >= this.keyToFactor.scattPlot.worst.outlierValues[0] && element.value <= this.keyToFactor.scattPlot.worst.outlierValues[1]));
      },
      usedDataRadarChartWorst() {
        let temp = [...this.keyToFactor.radarChart.worst.worstData];
        return temp.filter(element => (element.value >= this.keyToFactor.radarChart.worst.outlierValues[0] && element.value <= this.keyToFactor.radarChart.worst.outlierValues[1]));
      },
      removedDataRadarChartWorst() {
        let temp = [...this.keyToFactor.radarChart.worst.worstDataRemoved];
        return temp.filter(element => (element.value >= this.keyToFactor.radarChart.worst.outlierValues[0] && element.value <= this.keyToFactor.radarChart.worst.outlierValues[1]));
      },
      usedDataPieChartWorst() {
        let temp = [...this.keyToFactor.pieChart.worst.worstData];
        return temp.filter(element => (element.value >= this.keyToFactor.pieChart.worst.outlierValues[0] && element.value <= this.keyToFactor.pieChart.worst.outlierValues[1]));
      },
      removedDataPieChartWorst() {
        let temp = [...this.keyToFactor.pieChart.worst.worstDataRemoved];
        return temp.filter(element => (element.value >= this.keyToFactor.pieChart.worst.outlierValues[0] && element.value <= this.keyToFactor.pieChart.worst.outlierValues[1]));
      },
      usedDataLineChartWorst() {
        let temp = [...this.keyToFactor.lineChart.worst.worstData];
        return temp.filter(element => (element.value >= this.keyToFactor.lineChart.worst.outlierValues[0] && element.value <= this.keyToFactor.lineChart.worst.outlierValues[1]));
      },
      removedDataLineChartWorst() {
        let temp = [...this.keyToFactor.lineChart.worst.worstDataRemoved];
        return temp.filter(element => (element.value >= this.keyToFactor.lineChart.worst.outlierValues[0] && element.value <= this.keyToFactor.lineChart.worst.outlierValues[1]));
      },
    },
    methods: {
      getBrowserInfo() {
        let ua = navigator.userAgent;
        let name, version;

        if (ua.indexOf("Chrome") !== -1) {
            name = "Google Chrome";
            version = ua.match(/Chrome\/([\d.]+)/)[1];
        } else if (ua.indexOf("Firefox") !== -1) {
            name = "Mozilla Firefox";
            version = ua.match(/Firefox\/([\d.]+)/)[1];
        } else if (ua.indexOf("Safari") !== -1) {
            name = "Safari";
            version = ua.match(/Version\/([\d.]+)/)[1];
        } else if (ua.indexOf("MSIE") !== -1 || ua.indexOf("Trident") !== -1) {
            name = "Internet Explorer";
            version = ua.match(/(?:MSIE |rv:)(\d+(\.\d+)?)/)[1];
        } else {
            name = "Unknown Browser";
            version = "N/A";
        }

        return {
            name: name,
            version: version.trim()
        };
      },
      reDrawGraphs(ref) {
        this.$refs[ref].drawChart();
      },
      toggleAllNavShows(variable) {
        this.showNavVariables.showTestScore = variable === "showTestScore";
        this.showNavVariables.showAttention = variable === "showAttention";
        this.showNavVariables.showSummary = variable === "showSummary";
        this.showNavVariables.showConfig = variable === "showConfig";
        this.showNavVariables.showInitInfo = variable === "showInitInfo";
        this.showNavVariables.showGraphs = variable === "showGraphs";
        this.showNavVariables.showRootCause = variable == "showRootCause";
        this.showNavVariables.toggleNavSelect = variable;
      },
      selectPill(side) {
        if (side == "left") {
          document.getElementById("leftPill").classList.add('selectedPillHalf');
          document.getElementById("rightPill").classList.remove('selectedPillHalf');
          this.showRegVariables.testScoreDefault = true;
        }
        else {
          document.getElementById("leftPill").classList.remove('selectedPillHalf');
          document.getElementById("rightPill").classList.add('selectedPillHalf');
          this.showRegVariables.testScoreDefault = false;
        }
      },
      rotateCategory(direction) {
        function positModulo(dividend, divisor) {
          return ((dividend % divisor) + divisor) % divisor;
        }
        const categArrayLength = this.categorizedDataInfo.groupedData.length;
        if (direction == "left") {
          this.categorizedDataInfo.groupedDataIndex = positModulo(this.categorizedDataInfo.groupedDataIndex - 1,categArrayLength);
        }
        else {
          this.categorizedDataInfo.groupedDataIndex = positModulo(this.categorizedDataInfo.groupedDataIndex + 1,categArrayLength);
        }
      },
      showPreview() {
        this.showRegVariables.preview = !this.showRegVariables.preview;
        let tempArray = this.list.filter(element => this.keyToFactor[element.ref].optsOut == false);
        this.listDisplayTextBoxes = tempArray.map(element => this.keyToFactor[element.ref]);
      },
      async downloadPDF() {
        try {
          let pageWidth = 595.276; //A4 pdf
          let leftMargin = 40; //.5555 inches
          let rightMargin = 40; 
          let contentWidth = pageWidth - leftMargin - rightMargin;
          let temp = [];

          let htmlInner = null;
          let ref = null;

          for (const value of this.listDisplayTextBoxes) {
            if (value.label == 'Bar Chart') {
              if (this.keyToFactor.barChart.worst.isActive) {
                temp.push(htmlToPdfmake(`
                  <h6>Bar Chart Worst</h6>
                `))
                ref = document.getElementById('barChartVertPDF').children[0].children[0];

                htmlInner = ref.outerHTML.replace(new RegExp('currentColor', 'g'), 'black');
                temp.push(htmlToPdfmake(htmlInner));
                ref.removeAttribute("viewBox");
              }
              if (this.keyToFactor.barChart.all.isActive) {
                temp.push(htmlToPdfmake(`
                  <h6>Bar Chart All</h6>
                `))
                ref = document.getElementById('barChartHorizPDF').children[0].children[0];
                ref.setAttribute("viewBox", "0 0 2250 500");
                htmlInner = ref.outerHTML.replace(new RegExp('currentColor', 'g'), 'black');
                temp.push(htmlToPdfmake(htmlInner));
                ref.removeAttribute("viewBox");
              }
            }
            else if (value.label == 'Scatter Plot') {
              if (this.keyToFactor.scattPlot.worst.isActive) {
                temp.push(htmlToPdfmake(`
                  <h6>Scatter Plot Worst</h6>
                `))
                ref = document.getElementById('scattPlotWorstPDF').children[0].children[0];
                ref.setAttribute("viewBox", "800 0 800 600");
                htmlInner = ref.outerHTML.replace(new RegExp('currentColor', 'g'), 'black');
                temp.push(htmlToPdfmake(htmlInner));
                ref.removeAttribute("viewBox");
              }
              if (this.keyToFactor.scattPlot.all.isActive) {
                temp.push(htmlToPdfmake(`
                  <h6>Scatter Plot All</h6>
                `))
                ref = document.getElementById('scattPlotAllPDF').children[0].children[0];
                ref.setAttribute("viewBox", "800 0 800 600");
                htmlInner = ref.outerHTML.replace(new RegExp('currentColor', 'g'), 'black');
                temp.push(htmlToPdfmake(htmlInner));
                ref.removeAttribute("viewBox");
              }
            }
            else if (value.label == 'Radar Chart') {
              if (this.keyToFactor.radarChart.worst.isActive) {
                temp.push(htmlToPdfmake(`
                  <h6>Radar Chart Worst</h6>
                `))
                ref = document.getElementById('radarChartWorstPDF').children[0];
                ref.setAttribute("viewBox", "450 0 500 500");
                htmlInner = ref.outerHTML;
                temp.push(htmlToPdfmake(htmlInner));
                ref.removeAttribute("viewBox");
              }
              if (this.keyToFactor.radarChart.all.isActive) {
                temp.push(htmlToPdfmake(`
                  <h6>Radar Chart All</h6>
                `))
                ref = document.getElementById('radarChartAllPDF').children[0];
                ref.setAttribute("viewBox", "450 0 500 500");
                htmlInner = ref.outerHTML;
                temp.push(htmlToPdfmake(htmlInner));
                ref.removeAttribute("viewBox");
              }
            }
            else if (value.label == 'Pie Chart') {
              if (this.keyToFactor.pieChart.worst.isActive) {
                temp.push(htmlToPdfmake(`
                  <h6>Pie Chart Worst</h6>
                `))
                ref = document.getElementById('pieChartWorstPDF').children[0];
                ref.setAttribute("viewBox", "450 0 500 500");
                htmlInner = ref.outerHTML;
                temp.push(htmlToPdfmake(htmlInner));
                ref.removeAttribute("viewBox");
              }
              if (this.keyToFactor.pieChart.all.isActive) {
                temp.push(htmlToPdfmake(`
                  <h6>Pie Chart All</h6>
                `))
                ref = document.getElementById('pieChartAllPDF').children[0];
                ref.setAttribute("viewBox", "600 0 500 500");
                htmlInner = ref.outerHTML;
                temp.push(htmlToPdfmake(htmlInner));
                ref.removeAttribute("viewBox");
              }
            }
            else if (value.label == 'Line Chart') {
              if (this.keyToFactor.lineChart.worst.isActive) {
                temp.push(htmlToPdfmake(`
                  <h6>Line Chart Worst</h6>
                `))
                ref = document.getElementById('lineChartWorstPDF').children[0].children[0];
                ref.setAttribute("viewBox", "800 0 800 600");
                htmlInner = ref.outerHTML.replace(new RegExp('currentColor', 'g'), 'black');
                temp.push(htmlToPdfmake(htmlInner));
                ref.removeAttribute("viewBox");
              }
              if (this.keyToFactor.lineChart.all.isActive) {
                temp.push(htmlToPdfmake(`
                  <h6>Line Chart All</h6>
                `))
                ref = document.getElementById('lineChartAllPDF').children[0].children[0];
                ref.setAttribute("viewBox", "800 0 800 600");
                htmlInner = ref.outerHTML.replace(new RegExp('currentColor', 'g'), 'black');
                temp.push(htmlToPdfmake(htmlInner));
                ref.removeAttribute("viewBox");
              }
            }
            else if (value.label == 'Category Comments') {
              temp.push(htmlToPdfmake(`
                <h6>Category Comments</h6>
              `))
              for (const item in value.list) {
                temp.push(htmlToPdfmake(`
                  <table>
                    <tr>
                      <th style="width: ${contentWidth}">${value.list[item].label}</th>
                    </tr>
                    <tr>
                      <td>
                        <div>${value.list[item].variable}</div>
                      </td>
                    </tr>
                  </table>
                `, {tableAutoSize: true}))
              }
            }
            else if ('variable' in value) {
              temp.push(htmlToPdfmake(`
              <table>
                <tr>
                  <th style="width: ${contentWidth}">${value.label}</th>
                </tr>
                <tr>
                  <td>
                    <div>${value.variable}</div>
                  </td>
                </tr>
              </table>
              `, {tableAutoSize: true}))
            }
            else if (value.label == 'Test Score') {
              temp.push(htmlToPdfmake(`
                <h6>Test Scores</h6>
              `))
              htmlInner = document.getElementById('tableDataPDF').innerHTML;
              temp.push(htmlToPdfmake(htmlInner));
            }
            else if (value.label == 'Subjective Scoring') {
              temp.push(htmlToPdfmake(`
                <div>
                  <h6 style="margin-bottom: 2px">Subjective Scoring</h6>
                  <div style="font-weight: 400">
                    A
                    <span>${this.keyToFactor.subScore.dropDownMood.selectedValue}</span> 
                    <span>${this.preferredName}</span> in 
                    <span>${this.keyToFactor.subScore.dropDownShirtColor.selectedValue}</span> 
                    shirt was seen for evaluation of 
                    <span>${this.appSubtitle}</span>.
                    <span>${this.includeCateg}</span>
                    type questions were included in the screening.
                  </div>
                </div>
              `))
              htmlInner = document.getElementById('subjectiveScorePDF').innerHTML;
              temp.push(htmlToPdfmake(`
                <svg width="${contentWidth}" height="150">
                  ${htmlInner}
                </svg>
              `));
            }
          }
          
          let totalScoreCircle = document.getElementById('totalScoreCirclePDF').innerHTML;
          totalScoreCircle = (htmlToPdfmake(totalScoreCircle));

          let totalScoreTable = document.getElementById('totalScoreTablePDF').innerHTML;
          totalScoreTable = (htmlToPdfmake(totalScoreTable));

          let docDefinition = {
            content: [
              {
                text: "Final Report",
                fontSize: 40,
                alignment: 'center'
              },
/*               {
                columns: [
                  {
                    width: 200,
                    stack: [
                      {
                        image: chartResults[0].toDataURL('image/png'),
                        width: 100,
                        alignment: 'center'
                      },
                      {
                        text: this.preferredName,
                        alignment: 'center',
                        fontSize: 18
                      }
                    ]
                  },
                  {
                    table: {
                      widths: ['*','*'],
                      body: [
                        ['Date of Birth:', 'School:'],
                        ['Sample value 1', 'Sample value 2'],
                        ['Age:', 'Buildings/Room:'],
                        ['Sample value 1', 'Sample value 2'],
                        ['Parent/Guardian', 'Total %'],
                        ['Age:', 'Buildings/Room:'],
                      ]
                    },
                    layout: {
                      fillColor: function (rowIndex) {
                        return (rowIndex % 2 === 0) ? '#CCCCCC' : null;
                      }
                    },
                  }
                ],
                margin: [0, 25]
              }, */
              {
                stack: [
                  {
                    text: "Total Score",
                    alignment: 'center'
                  },
                  {
                    columns: [
                      totalScoreCircle,
                      totalScoreTable
                    ]
                  }
                ]
              },
              temp,
            ]
          }
          pdfMake.createPdf(docDefinition).open()
        } catch (e) {
          console.error('Error', e);
        }
      },
      changePastWorstCateg(label) {
        this.keyToFactor.barChart.worst.pastChoose.forEach(item => {
          item.isActive = item.label === label;
        });
      },
      chooseGraphics(label) {
        const threeRef = document.getElementById('selectWorst3Opt');
        const allRef = document.getElementById('selectAllOpt');

        //categories selection
        if (label === "worse 3" || label === "all") {
          let shortenRef = this.plotVariables.plotSelect;
          for (const item in shortenRef) {
            if (shortenRef[item].isActive && !this.keyToFactor[item].optsOut) {
              if (label === "worse 3") {
                this.keyToFactor[shortenRef[item].ref].worst.isActive = !this.keyToFactor[shortenRef[item].ref].worst.isActive;
                threeRef.classList.toggle('categGraphSelected');
              }
              else {
                this.keyToFactor[shortenRef[item].ref].all.isActive = !this.keyToFactor[shortenRef[item].ref].all.isActive;
                allRef.classList.toggle('categGraphSelected');
              }
              return;
            }
          }
        }
        else {
          //types selection
          let shortenRef = this.plotVariables.plotSelect;
          for (let item in shortenRef) {
            if (shortenRef[item].label === label) {
              if (this.keyToFactor[shortenRef[item].ref].optsOut) {
                return;
              }
            }
            shortenRef[item].isActive = shortenRef[item].label === label;
            if (shortenRef[item].isActive) {
              this.keyToFactor[shortenRef[item].ref].worst.isActive ? threeRef.classList.add('categGraphSelected') : threeRef.classList.remove('categGraphSelected');
              this.keyToFactor[shortenRef[item].ref].all.isActive ? allRef.classList.add('categGraphSelected') : allRef.classList.remove('categGraphSelected');
            }
          }
        }
      },
      toggleGeneralDropDowns(label) {
        if (label == 'mood') {
          this.keyToFactor.subScore.dropDownMood.isDropdownOpen = !this.keyToFactor.subScore.dropDownMood.isDropdownOpen; 
        }
        else if (label == 'shirtColor') {
          this.keyToFactor.subScore.dropDownShirtColor.isDropdownOpen = !this.keyToFactor.subScore.dropDownShirtColor.isDropdownOpen; 
        }
        else if (label == 'weakest') {
          this.keyToFactor.barChart.worst.dropDownWeakest.isDropdownOpen = !this.keyToFactor.barChart.worst.dropDownWeakest.isDropdownOpen; 
        }
      },
      selectOptionGeneral(option, label) {
        if (label == 'mood') {
          this.keyToFactor.subScore.dropDownMood.selectedValue = option; 
          this.keyToFactor.subScore.dropDownMood.isDropdownOpen = false; 
        }
        else if (label == 'shirtColor') {
          this.keyToFactor.subScore.dropDownShirtColor.selectedValue = option; 
          this.keyToFactor.subScore.dropDownShirtColor.isDropdownOpen = false; 
        }
        else if (label == 'barChartWeak3') {
          this.keyToFactor.barChart.worst.dropDownWeakest.selectedValue = option; 
          this.keyToFactor.barChart.worst.dropDownWeakest.isDropdownOpen = false; 
        }
      },
      toggleCustomizeDropDown(plot, type) {
        type == 'worst' ? this.keyToFactor[plot]['worst'].plotCustomize.dropDownActive = !this.keyToFactor[plot]['worst'].plotCustomize.dropDownActive
          : this.keyToFactor[plot]['all'].plotCustomize.dropDownActive = !this.keyToFactor[plot]['all'].plotCustomize.dropDownActive;
      },
      toggleCustomizeSideBar(plot, type) {
        type == 'worst' ? this.keyToFactor[plot]['worst'].plotCustomize.sideBarActive = !this.keyToFactor[plot]['worst'].plotCustomize.sideBarActive
          : this.keyToFactor[plot]['all'].plotCustomize.sideBarActive = !this.keyToFactor[plot]['all'].plotCustomize.sideBarActive;
      },
      checkMoveWorst(e) {
        return e.to.childElementCount >= 3 ? false : null; 
      },
      createObjectURL(file) {
        return URL.createObjectURL(file);
      },
      openModal(name, data) {
        if (name == "more-question-info-modal") {
          this.modalData.moreQuestionInfo = data;
        }
        document.getElementById(name).style.display = 'block';
      },
      closeModal(name) {
        document.getElementById(name).style.display = 'none';
      },
      changeProfPic(e) {
        const file = e.target.files[0];
        this.profilePicTemp = URL.createObjectURL(file);
      },
      saveProfPic() {
        this.profilePic = this.profilePicTemp;
      },
      applyTableRowColor(question) {
        if (question.skipped) {
          return '#ECECEC';
        } else if (question.highest_possible_score == question.selected_score) {
          return '#ace2c6';
        } else if (question.selected_score == 0) {
          return '#FEF0D6';
        } else if (question.selected_score > 0 && question.selected_score < question.highest_possible_score) {
          return '#d9f2e6';
        } else {
          return '#eab8b8';
        }
      },
      physicalMappingButton() {
        alert('Please refer to win3hub for this portion');
      },
      compareSettingsButton() {
        alert('jeflkjek')
      },
      compareSimiliarButton() {
        alert('jkljlkjlk')
      },
      scoreCategoryConversion() {
        let score = this.dataDetails.correctScore/this.dataDetails.maxScore;
        if (score >= .75) {
          return "Above Typical";
        } else if (score >= .50) {
          return "Typical";
        } else if (score >= .25) {
          return "Needs Improvement";
        } else if (score >= .0) {
          return "Severe";
        }
      },
      toggleAccordion(event) {
        let ref = event.target;
        ref.classList.toggle('accordion-active');
        let panel = ref.nextElementSibling;
        if (panel.style.maxHeight) {
          panel.style.maxHeight = null;
        } else {
          panel.style.maxHeight = panel.scrollHeight + "px";
        }
      },
      lowerSliderChange(event, object) {
        let lower = Number(event.target.value);
        let upper = Number(event.target.nextSibling.value);
        let track = event.target.parentNode.lastChild;
        if (lower >= upper) {
          event.target.value = upper;
        }
        object.outlierValues = [lower, upper];
        track.style.background = `linear-gradient(to right, #000000 ${((lower/100)*100).toFixed(2)}%, #466496 ${((lower/100)*100).toFixed(2)}%, #466496 ${((upper/100)*100).toFixed(2)}%, #000000 ${((upper/100)*100).toFixed(2)}%)`;
      },
      upperSliderChange(event, object) {
        let lower = Number(event.target.previousSibling.value);
        let upper = Number(event.target.value);
        let track = event.target.parentNode.lastChild;
        if (lower >= upper) {
          event.target.value = lower;
        }
        object.outlierValues = [lower, upper];
        track.style.background = `linear-gradient(to right, #000000 ${((lower/100)*100).toFixed(2)}%, #466496 ${((lower/100)*100).toFixed(2)}%, #466496 ${((upper/100)*100).toFixed(2)}%, #000000 ${((upper/100)*100).toFixed(2)}%)`;
      },
    }
  };
</script>

<style lang="scss" scoped>
  $sidebar-width: 300px;
	$reportOrange: #FF9B00;
	$reportOrangeLight: #eecc9a;
  
  textarea {
    width: 100%;
  }
  
  .accordion-container {
    .accordion {
      background-color: #eee;
      color: #444;
      cursor: pointer;
      padding: 18px;
      width: 100%;
      border: none;
      text-align: left;
      outline: none;
      font-size: 15px;
    }

    .accordion-active, .accordion:hover {
      background-color: #ccc;
    }

    .panel {
      padding: 0 18px;
      background-color: white;
      max-height: 0;
      overflow: hidden;
      transition: max-height 0.2s ease-out;
    }
  }

  #container {
    padding-top: 0;
    padding-bottom: 0;
  }

  #main-box {
    margin-left: $sidebar-width;
    padding: 1.5rem;
  }

  #sideBar-box {
    width: $sidebar-width;
    position: fixed;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 100vh;
    overflow: auto;
    background-color: #f0d1a4;

    .logo {
      width: 50%;
      height: auto;
    }
    
    .navText:hover {
      opacity: .5;
      background-color: $reportOrange;
    }

    .navText span {
      margin-left: 1rem;
    }

    .navClick {
      background-color: $reportOrange;
      position: relative;
    }

    .orange-button {
      border: solid black 1px;
      background-color: $reportOrange;
      width: 75%;
      padding: .25rem;
      border-radius: 50rem;
      align-self: center;
      margin: 5px;
    }
  }

  .modal-section-container {
    .modal {
      display: none;
      position: fixed;
      z-index: 1;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      overflow: auto;
      background-color: rgba(0,0,0,0.4);
    }

    .modal-content {
      background-color: #fefefe;
      margin: 20% auto;
      padding: 20px;
      border: 1px solid #888;
      width: 80%;
    }

    button {
      background-color: $reportOrange;
      border-radius: 50rem;
    }
  }

  #Initial-Info-container {
    position: relative;

    #button-navigation-container {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      position: fixed;
      right: 1px;
      top: 50%;
      transform: translateY(-50%);
      background-color: $reportOrangeLight;
      padding: 1px;
      z-index: 5;

      > span {
        font-weight: 400;
        font-size: 1.5rem;
        display: flex;
        justify-content: center;
        align-items: center;
        background-color: #D9D9D9;
        width: 35px;
        height: 35px;
        margin: 1px 0;
      }
    }

    .profile-photo-container {
      height: 250px;
      width: 250px;
      border-radius: 50%;
      overflow: hidden;
    }

    .preview-textBoxes {
      background-color: $reportOrangeLight;
      border-radius: 8px;
      border: 2px $reportOrange solid;
      min-height: 150px;
    }

    .preview-InfoLabels {
      font-size: larger
    }

    .preview-InfoText {
      background-color: $reportOrangeLight;
    }

    .custom-slider-step {
      border-left: 2px solid #8CB7DF;
      height: 10px;
    }

    #initInfo-grid {
      display: grid;
      grid-template-columns: auto auto;
      column-gap: 2rem;

      div:nth-child(4n),
      div:nth-child(4n-1) {
        background-color: $reportOrangeLight;
        border-radius: 50rem;
        padding: 2px 1rem;
      }
    }

    .custom-slider-container {
      $thumb-width: 30px;
      position: relative;
      padding: 3rem 0;
      display: flex;
      align-items: center;
      justify-content: center;
      width: 100%;

      input[type="range"] {
        -webkit-appearance: none;
        appearance: none;
        width: 100%;
        cursor: pointer;
        outline: none;
        border-radius: 15px;
        height: 4px;
        
        &::-webkit-slider-thumb {
          -webkit-appearance: none;
          appearance: none;
          height: $thumb-width;
          width: $thumb-width;
          background-color: $reportOrange;
          border-radius: 50%;
          border: none;
          transition: .2s ease-in-out;
          position: relative;
          z-index: 20;
        }
      }

      .track {
        height: 2px;
        background: linear-gradient(to right, #FF4444 44.5%, #FAFF00 44.5%, #FAFF00 77.75%, #00FF29 77.75%);
        position: absolute;
        width: calc(100% - 30px);
        top: 50%;
        transform: translateY(-50%);
        padding: 0 15px;
      }

      .sliderticks {
        display: flex;
        justify-content: space-between;
        position: absolute;
        width: 100%;
        top: 50%;
        transform: translateY(-50%);
        padding: 0 15px;
      }

      .sliderticks span {
        display: flex;
        justify-content: center;
        width: 2px;
        height: 30px;
        background: #0FA958;
        line-height: 90px;
        position: relative;
        z-index: 30;
      }
    }

    .toggle-slider-container {
      position: relative;
      display: inline-block;
      width: 60px;
      height: 25px;
      margin: 0;

      input[type="checkbox"] {
        display: none;
      }

      .slider {
        position: absolute;
        cursor: pointer;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-color: $reportOrangeLight;
        transition: .4s;
        border-radius: 50rem;
      }

      .slider:before {
        position: absolute;
        content: "";
        height: 17px;
        width: 17px;
        left: 4px;
        bottom: 4px;
        background-color: #848383;
        transition: .4s;
        border-radius: 50%;
      }

      input:checked + .slider {
        background-color: $reportOrange;
      }

      input:checked + .slider:before {
        transform: translateX(35px);
        background-color: black;
      }
    }
  }

  #Config-Order-container {
    .drag-item {
      cursor: grab;
      font-size: medium;
      display: grid;
      grid-template-columns: 15px auto 100px;
    }

    .drag-item-deactivated {
      cursor: grab;
      display: grid;
      grid-template-columns: 25px auto 25px;
      opacity: .5;
      position: relative;
    }

    .drag-item-deactivated::before {
      content: "";
      position: absolute;
      top: 50%;
      left: 0;
      right: 0;
      border-top: 1px solid black;
    }
  }

  #Test-Scores-container {
    .strongest-weakest-category-container {
      display: flex;
      justify-content: flex-end;
      margin: 5px;

      .grid-container {
        display: grid;
        grid-template-columns: 200px 200px;
        column-gap: 10px;
        font-weight: 400;
        text-align: center;
      }

      .centering {
        display: flex;
        justify-content: center;
      }

      .strongest-text, .weakest-text {
        border-radius: 5px;
        width: 80%;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
      }

      .strongest-text {
        background-color: #CFEEDE;
      }

      .weakest-text  {
        background-color: #FEF0D6;
      }
    }

    .simpleBackground {
      background-color: $reportOrangeLight;
    }

    .round-search {
      width: 30%;
      border: $reportOrange 2px solid;
      background-color: $reportOrangeLight;
    }

    .round-search input[type="text"] {
      border: none;
      outline: none;
      width: 100%;
      font-size: 12px;
      font-weight: 400;
    }

    .half-pill {
      display: inline-block;
      height: 30px;
      padding-left: 10px;
      padding-right: 10px;
      cursor: default;
    }

    .left-half {
      border-radius: 15px 0 0 15px;
      border: 2px solid #CCCCCC;
    }

    .right-half {
      border-radius: 0 15px 15px 0;
      border: 2px solid #CCCCCC;
    }

    .selectedPillHalf {
      border: 2px solid $reportOrange;
      background-color: $reportOrangeLight;
    }

    .gridParent-categ {
      display: grid;
      grid-template-columns: 70% 30%;

      #quill-categComment .ql-container {
        height: 60vh;
      }

      #quill-categComment .ql-toolbar {
        background-color:$reportOrangeLight;
        border: 2px $reportOrange solid;
      }
    }

    table {
      text-align: center;

      .tableHeader {
        background-color: $reportOrangeLight;
        border: solid $reportOrange 2px;
      }

      .tableHeader th {
        padding: .5rem;
        width: auto;
      }

      .tableElements > td {
        border: solid #F0D1A4 1px;
        border-top-color: #B0B3B8;
        border-bottom-color: #B0B3B8;
        border-left-color: #F0D1A4;
        border-right-color: #F0D1A4;
        padding: 5px;
      }

      .tableElements-button {
        background-color: #8CB7DF;
        border-bottom-left-radius: 5px;
        border-bottom-right-radius: 5px;
      }
    }

    .media-icons-container {
      > span {
        position: relative;
        display: inline-block;
      }

      > span > * {
        margin: 0 2px;
      }

      .red-dot {
        height: 3px;
        width: 3px;
        background-color: red;
        border-radius: 50%;
        display: inline-block;
        position: absolute;
        top: 0;
        right: 0;
      }
    }
  }

  #Attention-Emotion-container {
    
  }

  #Graphs-Plots-container {
    .custom-slider-container {
      $thumb-width: 30px;
      position: relative;
      padding: 3rem 0;
      display: flex;
      align-items: center;
      justify-content: center;
      width: 100%;

      input[type="range"] {
        -webkit-appearance: none;
        appearance: none;
        position: absolute;
        width: 100%;
        cursor: pointer;
        outline: none;
        border-radius: 15px;
        height: 4px;
        
        &::-webkit-slider-thumb {
          -webkit-appearance: none;
          appearance: none;
          height: $thumb-width;
          width: $thumb-width;
          background-color: $reportOrange;
          border-radius: 50%;
          border: none;
          transition: .2s ease-in-out;
          position: relative;
          z-index: 20;
        }
      }

      .track {
        height: 5px;
        border-radius: 50rem;
        background-color: #466496;
        position: absolute;
        width: calc(100% - 30px);
        top: 50%;
        transform: translateY(-50%);
        padding: 0 15px;
      }
    }

    .radioGrid {
      display: grid;
      grid-template-columns: 150px 150px 150px 150px 150px 150px;
    }

    .categGraphOptions {
      display: inline-block;
      width: 15px;
      height: 15px;
      background-color: #ccc;
    }

    .categGraphSelected {
      background-color: $reportOrange;
    }

    .categGraphOptedOut {
    }

    .pillSelection {
      font-size: .6em;
      background-color: #D9D9D9;
      width: 450px;
    }

    .pillSelection span {
      flex: 1;
      white-space: nowrap;
      text-align: center;
    }

    .pillSelected {
      background-color: $reportOrangeLight;
    }

    .plotDrop-container {
      margin-top: 5px;
    }

    .plotDrop-title {
      background-color: $reportOrangeLight;
      border: 2px solid $reportOrange;
      border-radius: 3px;
    }

    .plotDrop-title:hover {
      opacity: .8;
    }

    .plotDrop-sideBar {
      background-color: rgb(240, 240, 240);
      position: absolute;
      left: 0;
      top: 0;
      width: 0;
      font-size: .7em;
      overflow: auto;
    }

    .plotDrop-sideBar-open {
      width: 100%;
      height: 100%;
      max-height: 900px;
      padding: 1rem;
    }

    .plotDrop-customizeB {
      text-align: center;
      width: 90%;
      background-color: #D7DCE1;
      border: 2px solid #b1b4b8;
      border-radius: 3px;
    }

    .plotDrop-customizeB:hover {
      opacity: .8;
    }

    .plotDrop-draggable-used {
      flex: 1;
      border: 2px solid $reportOrange;
      border-radius: 5px;
      margin: 5px;
      padding: 10px;
      display: flex;
      flex-direction: column;
    }

    .plotDrop-draggable-removed {
      flex: 1;
      border: 2px solid $reportOrange;
      padding: 10px;
      border-radius: 5px;
      margin: 5px;
      display: flex;
      flex-direction: column;
    }
  }

  #Root-Cause-Analysis-container {
    button {
      background-color: $reportOrange;
      border-radius: 10px;
      padding: 0 10px;
    }

    .nav-button-group {
      display: flex;
      justify-content: flex-end;

      button {
        margin: 0 2px;
      }
    }
  }

  #Summary-Recomm-container {

  }

  #Preview-container {

  }

/*   .navClick::before {
    content: '';
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    right: -10px;
    width: 0;
    height: 0;
    border-top: 10px solid transparent;
    border-bottom: 10px solid transparent;
    border-left: 10px solid $reportOrange;
    z-index: 30;
  } */

  /* TextBox */
  .textBox1, .infoBox, #obserComments, #atteSocEmoFunc, #riskSum, #summConclus,
  #furthTask, #techDetail {
    background-color: $reportOrangeLight;
    border-radius: 8px;
    border: 2px $reportOrange solid;
  }

	.textBox1 {
		min-height: 200px;
	}

  .infoBox {
    min-height: 150px;
  }

  /* Review Summary */
  .displayCard {
    display: inline-flex;
    flex-direction: column;
    box-shadow: 0px 2px 2px lightgrey;
    border-radius: 20px;
    border: solid lightgrey 1px;
  }

  /* dropdown */
  .selected-option {
    padding: 10px;
    border: 1px solid #ccc;
    cursor: pointer;
    font-weight: 400;
    font-size: medium;
    border-radius: 10px;
  }

  .custom-dropdown {
    position: relative;
    display: inline-block;
  }

  .custom-dropdown ul {
    list-style: none;
    margin: 0;
    position: absolute;
    background-color: #fff;
    border: 1px solid #ccc;
    border-radius: 10px;
    z-index: 1;
  }

  .custom-dropdown ul li {
    padding: 10px;
    cursor: pointer;
    font-weight: 400;
    font-size: smaller;
  }

  .custom-dropdown ul li:hover {
    background-color: #f1f1f1;
  }

</style>